/* Extracted from sections/custom-main-product.liquid to keep the section under Shopify's 256KB limit. */
/* DO NOT add Liquid tags to this file. */

document.addEventListener('DOMContentLoaded', function() {
    // Robustly detect section id.
    // The section can render in multiple contexts (main product, quick add, etc) so we prefer
    // reading it from our injected JSON script tags (which are guaranteed to exist when this section is on the page).
    const _variantsDataAny = document.querySelector('script[id^="custom-main-product-variants-data-"]');
    const _cmpSectionId =
      (_variantsDataAny && _variantsDataAny.id && _variantsDataAny.id.split('custom-main-product-variants-data-')[1]) ||
      (document.querySelector('section[id^="MainProduct-"][data-section]')?.getAttribute('data-section')) ||
      null;
    const normalizeSizeLabel = window.normalizeSizeLabel || ((size) => String(size || ''));
    const normalizeSizeKey = window.normalizeSizeKey || ((size) => String(size || '').toUpperCase());

    const _builderCfgEl = document.querySelector('script[id^="custom-main-product-builder-config-"]');
    let cmpBuilderConfig = {
      profile: 'apparel',
      embroideryBulkMinQuantity: 10,
      disableEmbroideryAutoSwitchToDigital: false,
      headwearStyle: 'cap',
      customisationVariantsJson: '',
      customisationPricesJson: ''
    };
    try {
      if (_builderCfgEl && _builderCfgEl.textContent.trim()) {
        cmpBuilderConfig = Object.assign({}, cmpBuilderConfig, JSON.parse(_builderCfgEl.textContent));
      }
    } catch (e) { /* keep defaults */ }
    window.__CMP_BUILDER_CONFIG = cmpBuilderConfig;

    function cmpMergeDeep(target, source) {
      if (!source || typeof source !== 'object') return target;
      Object.keys(source).forEach(function (k) {
        const sv = source[k];
        const tv = target[k];
        if (sv && typeof sv === 'object' && !Array.isArray(sv) && tv && typeof tv === 'object' && !Array.isArray(tv)) {
          cmpMergeDeep(tv, sv);
        } else {
          target[k] = sv;
        }
      });
      return target;
    }

    function cmpEmbroideryBulkMin() {
      const n = Number(window.__CMP_BUILDER_CONFIG && window.__CMP_BUILDER_CONFIG.embroideryBulkMinQuantity);
      return Number.isFinite(n) && n > 0 ? Math.floor(n) : 10;
    }

    // Note: We don't bail early if section ID isn't found because the grid builder
    // has fallbacks to find JSON data scripts by partial ID match, so it can still work.
                
                // Customisation variants map: method + size -> variant ID
                let CUSTOMISATION_VARIANTS = {
                  'Digital Print': {
                    'Small': '54640950575395',
                    'Medium': '55708024471843',
                    'Large': '54640950608163',
                    'XL': '55708024504611'
                  },
                  'Embroidery': {
                    'Small': '54640950640931',
                    'Large': '54640950673699'
                  }
                };

                try {
                  if (cmpBuilderConfig.customisationVariantsJson && String(cmpBuilderConfig.customisationVariantsJson).trim()) {
                    cmpMergeDeep(CUSTOMISATION_VARIANTS, JSON.parse(cmpBuilderConfig.customisationVariantsJson));
                  }
                } catch (e) { /* ignore invalid theme JSON */ }
                
                // Expose on window for access from liquid templates
                window.CUSTOMISATION_VARIANTS = CUSTOMISATION_VARIANTS;
                
                // Hardcoded prices for customisation variants (in cents)
                // These are fallback prices - actual prices should be fetched from variant IDs via API
                let CUSTOMISATION_VARIANT_PRICES = {
                  '54640950575395': 900,  // Digital Print Small - $9.00
                  '55708024471843': 1300,  // Digital Print Medium - $13.00
                  '54640950608163': 1400,  // Digital Print Large - $14.00 (live price fetched from the variant)
                  '55708024504611': 2100,  // Digital Print XL - $21.00
                  '54640950640931': 1400,  // Embroidery Small - $14.00
                  '54640950673699': 2800   // Embroidery Large - $28.00
                };

                try {
                  if (cmpBuilderConfig.customisationPricesJson && String(cmpBuilderConfig.customisationPricesJson).trim()) {
                    Object.assign(CUSTOMISATION_VARIANT_PRICES, JSON.parse(cmpBuilderConfig.customisationPricesJson));
                  }
                } catch (e) { /* ignore invalid theme JSON */ }
                
                // Expose on window for access from liquid templates
                window.CUSTOMISATION_VARIANT_PRICES = CUSTOMISATION_VARIANT_PRICES;
                
                // Global Quantity Tracker
                const stepTrackerText = document.getElementById('stepTrackerText');
                const volumeSlider = document.getElementById('volume-quantity-slider');
                
                // Helper: always read slider value as absolute quantity (no offsets).
                // This enforces the invariant: slider.value === displayed quantity === pricing input.
                window.getSliderQuantity = function() {
                  try {
                    return Number.parseInt(volumeSlider?.value, 10) || 0;
                  } catch (e) {
                    return 0;
                  }
                };
                // FIXED: Count from ONE source of truth to prevent double-counting
                window.updateQuantityTracker = function() {
                  const targetQty = parseInt(volumeSlider?.value) || 1;
                  let totalSelected = 0;
                  
                  // Count from grid view ONLY (grid and box sync each other, so counting both double-counts)
                  const gridInputs = document.querySelectorAll('#variantGridBody input[type="number"]');
                  if (gridInputs.length > 0) {
                    // Grid view is present - use it as source of truth
                    gridInputs.forEach(input => {
                      totalSelected += parseInt(input.value) || 0;
                    });
                  } else if (window.selectedColorSizes) {
                    // Fallback: grid not present (edge case), use box view data
                    Object.values(window.selectedColorSizes).forEach(colorData => {
                      Object.values(colorData).forEach(sizeData => {
                        totalSelected += (sizeData.qty || sizeData.quantity || 0);
                      });
                    });
                  }
                  
                  // Multi-colour notice: count colours that have at least one unit
                  const multiColourNotice = document.getElementById('multiColourNotice');
                  if (multiColourNotice) {
                    const coloursWithQty = new Set();
                    if (gridInputs.length > 0) {
                      gridInputs.forEach(input => {
                        if ((parseInt(input.value) || 0) > 0 && input.dataset.color) coloursWithQty.add(input.dataset.color);
                      });
                    } else if (window.selectedColorSizes) {
                      Object.entries(window.selectedColorSizes).forEach(([color, sizes]) => {
                        if (Object.values(sizes).some(d => (d.qty || d.quantity || 0) > 0)) coloursWithQty.add(color);
                      });
                    }
                    multiColourNotice.hidden = coloursWithQty.size < 2;
                  }

                  // Update step tracker
                  if (stepTrackerText) {
                    stepTrackerText.textContent = `${totalSelected} / ${targetQty} selected`;
                    stepTrackerText.classList.remove('complete', 'over');
                    
                    if (totalSelected === targetQty) {
                      stepTrackerText.classList.add('complete');
                    } else if (totalSelected > targetQty) {
                      stepTrackerText.classList.add('over');
                    }
                  }
                  
                  // Trigger pricing recalculation
                  if (window.recalculatePricing) {
                    window.recalculatePricing();
                  }
                };
                
                // View Toggle Functionality
                const viewToggle = document.getElementById('viewToggle');
                const boxesView = document.getElementById('variantBoxesView');
                const gridView = document.getElementById('variantGridSelector');
                
                // Hide non-Color/Size options in box view
                function hideNonColorSizeOptions() {
                  if (boxesView) {
                    const allOptions = boxesView.querySelectorAll('.product-form__input');
                    allOptions.forEach(option => {
                      const legend = option.querySelector('legend');
                      if (legend) {
                        const legendText = legend.textContent.trim().toLowerCase();
                        // Only show Color and Size options
                        if (!legendText.includes('color') && !legendText.includes('colour') && !legendText.includes('size')) {
                          option.classList.add('hide-option');
                        } else {
                          option.classList.remove('hide-option');
                        }
                      }
                    });
                  }
                }
                
                // Sync quantities from grid to box view
                window.syncGridToBox = function() {
                  const gridInputs = document.querySelectorAll('#variantGridBody input[type="number"]');
                  window.selectedColorSizes = window.selectedColorSizes || {};
                  
                  gridInputs.forEach(input => {
                    const qty = parseInt(input.value) || 0;
                    const color = input.dataset.color;
                    const size = input.dataset.size;
                    const variantId = input.dataset.variantId;
                    
                    if (color && size) {
                      if (!window.selectedColorSizes[color]) {
                        window.selectedColorSizes[color] = {};
                      }
                      
                      if (qty > 0) {
                        window.selectedColorSizes[color][size] = {
                          qty: qty,
                          variantId: variantId
                        };
                      } else {
                        // Remove if quantity is 0
                        delete window.selectedColorSizes[color][size];
                      }
                      
                      // Clean up empty color objects
                      if (Object.keys(window.selectedColorSizes[color]).length === 0) {
                        delete window.selectedColorSizes[color];
                      }
                    }
                  });
                  
                  // Update box view buttons to reflect selections
                  updateBoxViewButtons();
                }
                
                // Sync quantities from box to grid view
                window.syncBoxToGrid = function() {
                  if (!window.selectedColorSizes) return;
                  
                  const gridInputs = document.querySelectorAll('#variantGridBody input[type="number"]');
                  
                  // First reset all grid inputs to 0
                  gridInputs.forEach(input => {
                    input.value = '0';
                  });
                  
                  // Then set quantities from box view data
                  Object.entries(window.selectedColorSizes).forEach(([color, sizes]) => {
                    Object.entries(sizes).forEach(([size, data]) => {
                      const matchingInput = Array.from(gridInputs).find(input => 
                        input.dataset.color === color && input.dataset.size === size
                      );
                      
                      if (matchingInput && data.qty) {
                        matchingInput.value = data.qty;
                      }
                    });
                  });
                  
                  // Update grid summary
                  const updateGridSummaryEvent = new Event('input', { bubbles: true });
                  if (gridInputs.length > 0) {
                    gridInputs[0].dispatchEvent(updateGridSummaryEvent);
                  }
                }
                
                // Update box view buttons to show selections
                function updateBoxViewButtons() {
                  if (!window.selectedColorSizes) return;
                  
                  Object.entries(window.selectedColorSizes).forEach(([color, sizes]) => {
                    const wrapper = document.querySelector(`.color-variant-wrapper[data-color="${color}"]`);
                    if (wrapper) {
                      const total = Object.values(sizes).reduce((sum, item) => sum + (item.qty || 0), 0);
                      const btn = wrapper.querySelector('.select-sizes-btn');
                      
                      if (btn && total > 0) {
                        btn.textContent = `${total} units selected`;
                        btn.style.backgroundColor = '#28a745';
                        wrapper.classList.add('selected');
                      } else if (btn) {
                        btn.textContent = 'Select Sizes';
                        btn.style.backgroundColor = '';
                        wrapper.classList.remove('selected');
                      }
                    }
                  });
                }
                
                function switchView(isBoxView) {
                  if (isBoxView) {
                    // Sync grid to box before showing box view
                    if (window.syncGridToBox) {
                      window.syncGridToBox();
                    }
                    
                    boxesView.style.display = 'block';
                    gridView.style.display = 'none';
                    // Hide method options in box view
                    hideNonColorSizeOptions();
                    // Initialize collapsible view
                    initializeCollapsibleBoxView();
                  } else {
                    // Sync box to grid before showing grid view
                    if (window.syncBoxToGrid) {
                      window.syncBoxToGrid();
                    }
                    
                    boxesView.style.display = 'none';
                    gridView.style.display = 'block';
                    // Initialize collapsible grid view
                    if (window.initializeCollapsibleGridView) {
                      window.initializeCollapsibleGridView();
                    }
                  }
                  // Update tracker when switching views
                  if (window.updateQuantityTracker) {
                    window.updateQuantityTracker();
                  }
                  
                  // Trigger pricing recalculation
                  if (window.recalculatePricing) {
                    window.recalculatePricing();
                  }
                }
                
                // Collapsible Box View Functionality
                function initializeCollapsibleBoxView() {
                  const boxViewContainer = document.getElementById('boxViewContainer');
                  const viewMoreBtn = document.getElementById('viewMoreColorsBtn');
                  
                  if (!boxViewContainer || !viewMoreBtn) return;
                  
                  // Get all color variant wrappers
                  const colorBoxes = boxViewContainer.querySelectorAll('.color-variant-wrapper');
                  
                  if (colorBoxes.length <= 8) {
                    // If 8 or fewer colors, hide the view more button
                    viewMoreBtn.style.display = 'none';
                    return;
                  }
                  
                  // Show view more button
                  viewMoreBtn.style.display = 'flex';
                  
                  // Initially hide colors beyond the first 8
                  colorBoxes.forEach((box, index) => {
                    if (index >= 8) {
                      box.classList.add('color-box-hidden');
                    }
                  });
                  
                  // Reset button state
                  viewMoreBtn.classList.remove('expanded');
                  viewMoreBtn.querySelector('.view-more-text').textContent = 'View More Colours';
                }
                
                // View More Button Click Handler for Box View
                const viewMoreBtn = document.getElementById('viewMoreColorsBtn');
                if (viewMoreBtn) {
                  viewMoreBtn.addEventListener('click', function() {
                    const boxViewContainer = document.getElementById('boxViewContainer');
                    const colorBoxes = boxViewContainer.querySelectorAll('.color-variant-wrapper');
                    const isExpanded = this.classList.contains('expanded');
                    
                    if (isExpanded) {
                      // Collapse: hide colors beyond first 8
                      colorBoxes.forEach((box, index) => {
                        if (index >= 8) {
                          box.classList.add('color-box-hidden');
                        }
                      });
                      this.classList.remove('expanded');
                      this.querySelector('.view-more-text').textContent = 'View More Colours';
                    } else {
                      // Expand: show all colors
                      colorBoxes.forEach((box) => {
                        box.classList.remove('color-box-hidden');
                      });
                      this.classList.add('expanded');
                      this.querySelector('.view-more-text').textContent = 'View Less';
                    }
                  });
                }
                
                if (viewToggle) {
                  viewToggle.addEventListener('change', function() {
                    switchView(this.checked);
                  });
                  // Initialize with grid view (unchecked = grid)
                  switchView(false);
                  // Also hide options initially in case box view is default
                  hideNonColorSizeOptions();
                  
                  // Initialize sync on page load
                  if (window.selectedColorSizes && Object.keys(window.selectedColorSizes).length > 0 && window.syncBoxToGrid) {
                    window.syncBoxToGrid();
                  }
                }
                
                // Build Variant Grid
                // Try multiple methods to find the JSON data
                let _variantsEl = null;
                let _optionsEl = null;
                
                if (_cmpSectionId) {
                  _variantsEl = document.getElementById(`custom-main-product-variants-data-${_cmpSectionId}`);
                  _optionsEl = document.getElementById(`custom-main-product-options-data-${_cmpSectionId}`);
                }
                
                // Fallback: find by partial ID match
                if (!_variantsEl) {
                  _variantsEl = document.querySelector('script[id^="custom-main-product-variants-data-"]');
                }
                if (!_optionsEl) {
                  _optionsEl = document.querySelector('script[id^="custom-main-product-options-data-"]');
                }
                
                let productData = [];
                let productOptions = [];
                
                try {
                  if (_variantsEl && _variantsEl.textContent) {
                    productData = JSON.parse(_variantsEl.textContent);
                  }
                } catch (e) {
                  console.error('Error parsing product variants JSON:', e);
                }
                
                try {
                  if (_optionsEl && _optionsEl.textContent) {
                    productOptions = JSON.parse(_optionsEl.textContent);
                  }
                } catch (e) {
                  console.error('Error parsing product options JSON:', e);
                }
                
                const gridTable = document.getElementById('variantGridTable');
                const sizeHeaderRow = document.getElementById('sizeHeaderRow');
                const gridBody = document.getElementById('variantGridBody');
                
                // Debug logging
                console.log('Grid builder init:', {
                  sectionId: _cmpSectionId,
                  foundVariantsScript: !!_variantsEl,
                  foundOptionsScript: !!_optionsEl,
                  productDataLength: productData.length,
                  productOptionsLength: productOptions.length,
                  gridTable: !!gridTable,
                  sizeHeaderRow: !!sizeHeaderRow,
                  gridBody: !!gridBody
                });
                
                if (gridTable && productData && productData.length > 0 && productOptions && productOptions.length > 0) {
                  // Detect which option is Color and which is Size
                  let colorOptionIndex = -1;
                  let sizeOptionIndex = -1;
                  let otherOptionIndex = -1;
                  
                  productOptions.forEach((option, index) => {
                    const optionName = option.name.toLowerCase();
                    if (optionName.includes('color') || optionName.includes('colour')) {
                      colorOptionIndex = index;
                    } else if (optionName.includes('size')) {
                      sizeOptionIndex = index;
                    } else {
                      otherOptionIndex = index;
                    }
                  });
                  // Setup other option selector if exists
                  let selectedOtherOption = null;
                  const otherOptionContainer = document.getElementById('otherVariantOption');
                  const otherOptionLabel = document.getElementById('otherVariantLabel');
                  const otherOptionButtons = document.getElementById('otherVariantButtons');
                  
                  const otherIsDelivery = otherOptionIndex >= 0 && productOptions[otherOptionIndex] &&
                    productOptions[otherOptionIndex].name.toLowerCase().includes('delivery');

                  if (otherIsDelivery) {
                    // Delivery method is chosen in Step 2, so Step 3 has no picker of its own.
                    // Keep hidden buttons in sync so code reading '.other-variant-btn.active' still works.
                    const deliveryValues = productOptions[otherOptionIndex].values;
                    const pickDeliveryValue = () => {
                      const smartSaverRadio = document.getElementById('delivery-smart-saver');
                      const wantSmart = !!(smartSaverRadio && smartSaverRadio.checked);
                      return deliveryValues.find(v => {
                        const lower = v.toLowerCase();
                        return wantSmart ? (lower.includes('smart') || lower.includes('sea')) : lower.includes('standard');
                      }) || deliveryValues[0];
                    };
                    otherOptionContainer.style.display = 'none';
                    deliveryValues.forEach(value => {
                      const btn = document.createElement('button');
                      btn.type = 'button';
                      btn.className = 'other-variant-btn';
                      btn.textContent = value;
                      btn.dataset.value = value;
                      otherOptionButtons.appendChild(btn);
                    });
                    const syncDeliveryFromStep2 = () => {
                      selectedOtherOption = pickDeliveryValue();
                      otherOptionButtons.querySelectorAll('.other-variant-btn').forEach(b => {
                        b.classList.toggle('active', b.dataset.value === selectedOtherOption);
                      });
                    };
                    syncDeliveryFromStep2();
                    document.querySelectorAll('input[name="delivery-method"]').forEach(radio => {
                      radio.addEventListener('change', () => {
                        syncDeliveryFromStep2();
                        // Point each existing qty input at the matching variant for the new delivery
                        // method, so quantities already entered in Step 3 are kept.
                        gridBody.querySelectorAll('input[type="number"][data-variant-id]').forEach(input => {
                          const match = productData.find(variant =>
                            variant[`option${otherOptionIndex + 1}`] === selectedOtherOption &&
                            (colorOptionIndex < 0 || variant[`option${colorOptionIndex + 1}`] === input.dataset.color) &&
                            (sizeOptionIndex < 0 || normalizeSizeLabel(variant[`option${sizeOptionIndex + 1}`]) === input.dataset.size)
                          );
                          if (match) input.dataset.variantId = match.id;
                        });
                        const firstQty = gridBody.querySelector('input[type="number"]');
                        if (firstQty) firstQty.dispatchEvent(new Event('input', { bubbles: true }));
                      });
                    });
                  } else if (otherOptionIndex >= 0 && productOptions[otherOptionIndex]) {
                    const otherOption = productOptions[otherOptionIndex];
                    otherOptionContainer.style.display = 'block';
                    otherOptionLabel.textContent = otherOption.name + ':';
                    
                    // Create buttons for each value
                    otherOption.values.forEach((value, index) => {
                      const btn = document.createElement('button');
                      btn.type = 'button';
                      btn.className = 'other-variant-btn' + (index === 0 ? ' active' : '');
                      btn.textContent = value;
                      btn.dataset.value = value;
                      
                      btn.addEventListener('click', function() {
                        document.querySelectorAll('.other-variant-btn').forEach(b => b.classList.remove('active'));
                        this.classList.add('active');
                        selectedOtherOption = value;
                        rebuildGrid();
                      });
                      
                      otherOptionButtons.appendChild(btn);
                    });
                    
                    selectedOtherOption = otherOption.values[0];
                  }
                  
                  // Function to build/rebuild grid based on selected other option
                  function rebuildGrid() {
                    // Clear existing grid
                    while (sizeHeaderRow.children.length > 1) {
                      sizeHeaderRow.removeChild(sizeHeaderRow.lastChild);
                    }
                    gridBody.innerHTML = '';
                    
                    // Extract unique colors and sizes for selected other option
                    const colors = {};
                    const sizes = new Set();
                    
                    productData.forEach(variant => {
                      const color = colorOptionIndex >= 0 ? variant[`option${colorOptionIndex + 1}`] : null;
                      const rawSize = sizeOptionIndex >= 0 ? variant[`option${sizeOptionIndex + 1}`] : null;
                      const size = normalizeSizeLabel(rawSize);
                      const otherValue = otherOptionIndex >= 0 ? variant[`option${otherOptionIndex + 1}`] : null;
                      
                      // Skip if wrong other option value
                      if (selectedOtherOption && otherValue !== selectedOtherOption) {
                        return;
                      }
                      
                      // Skip if no color or size
                      if (!color || !rawSize) {
                        return;
                      }
                      
                      if (!colors[color]) {
                        colors[color] = {
                          image: variant.featured_image ? variant.featured_image.src : null,
                          sizes: {}
                        };
                      }
                      
                      colors[color].sizes[size] = {
                        variantId: variant.id,
                        available: variant.available,
                        price: variant.price
                      };
                      
                      sizes.add(size);
                    });
                  // Convert sizes to array and sort (XS, S, M, L, XL, etc.)
                  const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
                  const sizesArray = Array.from(sizes).sort((a, b) => {
                    const aIndex = sizeOrder.indexOf(normalizeSizeKey(a));
                    const bIndex = sizeOrder.indexOf(normalizeSizeKey(b));
                    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
                    if (aIndex !== -1) return -1;
                    if (bIndex !== -1) return 1;
                    return a.localeCompare(b);
                  });
                  
                  // Build header row
                  sizesArray.forEach(size => {
                    const th = document.createElement('th');
                    th.textContent = size;
                    sizeHeaderRow.appendChild(th);
                  });
                  
                  // Build rows for each color
                  Object.keys(colors).forEach(color => {
                    const row = document.createElement('tr');
                    
                    // Color cell
                    const colorCell = document.createElement('td');
                    const colorDiv = document.createElement('div');
                    colorDiv.className = 'color-cell';
                    
                    if (colors[color].image) {
                      const img = document.createElement('img');
                      img.src = colors[color].image;
                      img.alt = color;
                      img.className = 'color-image';
                      colorDiv.appendChild(img);
                    }
                    
                    const colorName = document.createElement('span');
                    colorName.className = 'color-name';
                    colorName.textContent = color;
                    colorDiv.appendChild(colorName);
                    
                    colorCell.appendChild(colorDiv);
                    
                    // Make color cell clickable to change image
                    colorCell.style.cursor = 'pointer';
                    colorCell.addEventListener('click', function() {
                      // Find and trigger the hidden color variant radio button
                      const colorRadios = document.querySelectorAll('input[type="radio"][name*="option"]');
                      colorRadios.forEach(radio => {
                        if (radio.value === color) {
                          radio.checked = true;
                          radio.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                      });
                    });
                    
                    row.appendChild(colorCell);
                    
                    // Size cells
                    sizesArray.forEach(size => {
                      const sizeData = colors[color].sizes[size];
                      const sizeCell = document.createElement('td');
                      sizeCell.className = 'qty-input-cell';
                      
                      if (sizeData && sizeData.available) {
                        const input = document.createElement('input');
                        input.type = 'number';
                        input.min = '0';
                        input.value = '0';
                        input.dataset.variantId = sizeData.variantId;
                        input.dataset.color = color;
                        input.dataset.size = size;
                        sizeCell.appendChild(input);
                      } else {
                        sizeCell.classList.add('unavailable');
                      }
                      
                      row.appendChild(sizeCell);
                    });
                    
                    gridBody.appendChild(row);
                  });
                  
                  // Handle quantity changes
                  const summaryDiv = document.getElementById('gridSelectionSummary');
                  const addToCartBtn = document.getElementById('gridAddToCart');
                  
                  function updateGridSummary() {
                    const inputs = gridBody.querySelectorAll('input[type="number"]');
                    let totalItems = 0;
                    const selections = [];
                    
                    inputs.forEach(input => {
                      const qty = parseInt(input.value) || 0;
                      if (qty > 0) {
                        totalItems += qty;
                        selections.push({
                          color: input.dataset.color,
                          size: input.dataset.size,
                          qty: qty,
                          variantId: input.dataset.variantId
                        });
                      }
                    });
                    
                    if (selections.length > 0) {
                      let html = '';
                      selections.forEach(sel => {
                        html += `<div class="summary-item">
                          <span>${sel.color} - ${sel.size}</span>
                          <span>×${sel.qty}</span>
                        </div>`;
                      });
                      html += `<div class="summary-item">
                        <span>Total Items</span>
                        <span>${totalItems}</span>
                      </div>`;
                      summaryDiv.innerHTML = html;
                      addToCartBtn.disabled = false;
                    } else {
                      summaryDiv.innerHTML = '';
                      addToCartBtn.disabled = true;
                    }
                    
                    // Update quantity tracker
                    if (window.updateQuantityTracker) {
                      window.updateQuantityTracker();
                    }
                  }
                  
                  // Listen for quantity changes
                  gridBody.addEventListener('input', function(e) {
                    if (e.target.type === 'number') {
                      updateGridSummary();
                      // Sync to box view whenever grid quantities change
                      if (window.syncGridToBox) {
                        window.syncGridToBox();
                      }
                      // Trigger pricing recalculation
                      if (window.recalculatePricing) {
                        window.recalculatePricing();
                      }
                    }
                  });
                  
                  // Handle Add to Cart
                  addToCartBtn.addEventListener('click', async function() {
                    const inputs = gridBody.querySelectorAll('input[type="number"]');
                    const items = [];
                    
                    // Get pricing data
                    const pricing = window.computeDisplayedPricing ? window.computeDisplayedPricing() : null;
                    const smartSaverRadio = document.getElementById('delivery-smart-saver');
                    const selectedDeliveryMethod = (smartSaverRadio && smartSaverRadio.checked) ? 'Smart Saver' : 'Standard';
                    
                    // Get weight for first variant
                    let unitWeightGrams = 440; // Fallback
                    if (inputs.length > 0 && inputs[0].dataset.variantId) {
                      unitWeightGrams = window.getWeightGramsForVariant ? window.getWeightGramsForVariant(inputs[0].dataset.variantId) : 440;
                    }
                    
                    inputs.forEach(input => {
                      const qty = parseInt(input.value) || 0;
                      if (qty > 0) {
                        const properties = {};
                        
                        // Add existing artwork properties if they exist (from print locations)
                        // These are already in the form, we just need to preserve them
                        
                        // Add pricing properties
                        if (pricing) {
                          properties['Delivery Method'] = selectedDeliveryMethod;
                          properties['Multiplier'] = String(pricing.multiplier);
                          properties['Volume Discount'] = `${Math.round(pricing.volumeDiscountRate * 100)}%`;
                          properties['Smart Saver Discount'] = `${Math.round(pricing.smartSaverDiscountRate * 100)}%`;
                          properties['Smart Saver MOQ'] = String(pricing.smartSaverMOQ || 0);
                          properties['Unit Weight (g)'] = String(unitWeightGrams);
                          properties['Displayed Unit Price'] = `$${(pricing.unitPriceFinal / 100).toFixed(2)}`;
                          properties['Displayed Total'] = `$${(pricing.totalFinal / 100).toFixed(2)}`;
                        } else {
                          // Fallback if pricing not available
                          properties['Delivery Method'] = selectedDeliveryMethod;
                          properties['Unit Weight (g)'] = String(unitWeightGrams);
                        }
                        
                        // Customer's design-colour notes from the multi-colour notice
                        const colourNotes = document.getElementById('multiColourNotes');
                        if (colourNotes && !document.getElementById('multiColourNotice')?.hidden && colourNotes.value.trim()) {
                          properties['Design Colour Notes'] = colourNotes.value.trim();
                        }

                        items.push({
                          id: input.dataset.variantId,
                          quantity: qty,
                          properties: properties
                        });
                      }
                    });
                    
                    // Add customisation variant line items (print locations + design tool prints)
                    const totalQty = window.getTotalQty ? window.getTotalQty() : 0;
                    const baseVariantIds = []; // Track which base variants are being added
                    inputs.forEach(input => {
                      const qty = parseInt(input.value) || 0;
                      if (qty > 0 && input.dataset.variantId) {
                        baseVariantIds.push(input.dataset.variantId);
                      }
                    });
                    const printLines = window.eaBuildPrintLines(baseVariantIds, totalQty);
                    const locationDetails = printLines.items.concat(printLines.artworkItems);
                    const artworkItems = printLines.artworkItems;
                    items.push(...printLines.items);
                    
                    console.log(`[AddToCart] Total items to add: ${items.length} (${items.length - locationDetails.length} base + ${locationDetails.length} customisation)`);
                    
                    if (items.length === 0) return;
                    
                    // Show loading
                    const btnText = addToCartBtn.querySelector('.cart-btn-text');
                    const btnLoading = addToCartBtn.querySelector('.cart-btn-loading');
                    btnText.style.display = 'none';
                    btnLoading.style.display = 'block';
                    addToCartBtn.disabled = true;
                    
                    try {
                      const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ items })
                      });

                      // Customisation lines that carry uploaded artwork
                      if (response.ok) await window.eaUploadArtworkLines(artworkItems);
                      
                      if (response.ok) {
                        // Success feedback
                        btnText.textContent = '✓ Added!';
                        btnText.style.display = 'block';
                        btnLoading.style.display = 'none';
                        
                        // Refresh cart
                        document.dispatchEvent(new CustomEvent('cart:refresh'));
                        
                        // Reset after 2 seconds
                        setTimeout(() => {
                          btnText.textContent = 'Add to Cart';
                          inputs.forEach(input => input.value = '0');
                          updateGridSummary();
                        }, 2000);
                      } else {
                        throw new Error('Failed to add to cart');
                      }
                    } catch (error) {
                      console.error('Error adding to cart:', error);
                      btnText.textContent = 'Error - Try Again';
                      btnText.style.display = 'block';
                      btnLoading.style.display = 'none';
                      addToCartBtn.disabled = false;
                      
                      setTimeout(() => {
                        btnText.textContent = 'Add to Cart';
                      }, 2000);
                    }
                  });
                  
                  // Initialize
                  updateGridSummary();
                  
                  // Reinitialize collapsible view after rebuild
                  if (window.initializeCollapsibleGridView) {
                    window.initializeCollapsibleGridView();
                  }
                  }
                  
                  // Build initial grid
                  rebuildGrid();
                }
                
                function clearGridPeekRowStyles(row) {
                  if (!row) return;
                  row.classList.remove('grid-row-peek');
                  row.querySelectorAll('td').forEach((td) => {
                    td.style.height = '';
                    td.style.overflow = '';
                    td.style.position = '';
                    td.style.paddingTop = '';
                    td.style.paddingBottom = '';
                    const inner = td.firstElementChild;
                    if (inner) inner.style.transform = '';
                  });
                }
                
                function applyGridPeekRow(peekRow) {
                  if (!peekRow) return;
                  clearGridPeekRowStyles(peekRow);
                  const fullH = peekRow.getBoundingClientRect().height;
                  if (fullH < 12) return;
                  const visiblePx = fullH / 2;
                  peekRow.classList.add('grid-row-peek');
                  peekRow.querySelectorAll('td').forEach((td) => {
                    td.style.overflow = 'hidden';
                    td.style.position = 'relative';
                    td.style.height = visiblePx + 'px';
                    td.style.paddingTop = '0';
                    td.style.paddingBottom = '4px';
                    const inner = td.firstElementChild;
                    if (inner) {
                      inner.style.transform = 'translateY(-' + (fullH - visiblePx) + 'px)';
                    }
                  });
                }
                
                function setGridCollapsedLayout(collapsed) {
                  const gridBody = document.getElementById('variantGridBody');
                  const viewMoreGridBtn = document.getElementById('viewMoreGridBtn');
                  const peekStack = document.getElementById('variantGridPeekStack');
                  if (!gridBody || !viewMoreGridBtn) return;
                  const gridRows = gridBody.querySelectorAll('tr');
                  const peekRow = gridRows[5];
                  const textEl = viewMoreGridBtn.querySelector('.view-more-text');
                  
                  if (collapsed) {
                    gridRows.forEach((row, index) => {
                      if (index < 6) {
                        row.classList.remove('grid-row-hidden');
                      } else {
                        row.classList.add('grid-row-hidden');
                      }
                    });
                    viewMoreGridBtn.classList.remove('expanded');
                    if (textEl) textEl.textContent = 'View More Colours';
                    if (peekStack) peekStack.classList.add('variant-grid-peek-stack--collapsed');
                    requestAnimationFrame(function () {
                      applyGridPeekRow(peekRow);
                    });
                  } else {
                    gridRows.forEach((row) => {
                      row.classList.remove('grid-row-hidden');
                    });
                    clearGridPeekRowStyles(peekRow);
                    viewMoreGridBtn.classList.add('expanded');
                    if (textEl) textEl.textContent = 'View Less';
                    if (peekStack) peekStack.classList.remove('variant-grid-peek-stack--collapsed');
                  }
                }
                
                // Collapsible Grid View Functionality - Define before using
                window.initializeCollapsibleGridView = function() {
                  const gridBody = document.getElementById('variantGridBody');
                  const viewMoreGridBtn = document.getElementById('viewMoreGridBtn');
                  const peekStack = document.getElementById('variantGridPeekStack');
                  
                  if (!gridBody || !viewMoreGridBtn) return;
                  
                  const gridRows = gridBody.querySelectorAll('tr');
                  
                  gridRows.forEach((row) => {
                    clearGridPeekRowStyles(row);
                    row.classList.remove('grid-row-hidden', 'grid-row-peek');
                  });
                  
                  if (peekStack) {
                    peekStack.classList.remove('variant-grid-peek-stack--collapsed');
                  }
                  
                  if (gridRows.length <= 5) {
                    viewMoreGridBtn.style.display = 'none';
                    viewMoreGridBtn.classList.remove('expanded');
                    const t = viewMoreGridBtn.querySelector('.view-more-text');
                    if (t) t.textContent = 'View More Colours';
                    return;
                  }
                  
                  viewMoreGridBtn.style.display = 'flex';
                  viewMoreGridBtn.classList.remove('expanded');
                  const resetText = viewMoreGridBtn.querySelector('.view-more-text');
                  if (resetText) resetText.textContent = 'View More Colours';
                  
                  setGridCollapsedLayout(true);
                };
                
                // View More Grid Button Click Handler
                const viewMoreGridBtn = document.getElementById('viewMoreGridBtn');
                if (viewMoreGridBtn) {
                  viewMoreGridBtn.addEventListener('click', function() {
                    const isExpanded = this.classList.contains('expanded');
                    if (isExpanded) {
                      setGridCollapsedLayout(true);
                    } else {
                      setGridCollapsedLayout(false);
                    }
                  });
                }
                
                // Initialize grid collapse on page load (grid is default view)
                if (window.initializeCollapsibleGridView) {
                  window.initializeCollapsibleGridView();
                }
                
                // Get elements
                const uploadToggleBtn = document.getElementById('uploadFilesToggle');
                const designSectionWrapper = document.getElementById('designSectionWrapper');
                const addBtn = document.getElementById('addPrintLocation');
                const designNowBtn = document.getElementById('designNowBtn');
                
                // Toggle Design Section (Upload Files)
                let isFirstOpen = true;
                if (uploadToggleBtn && designSectionWrapper) {
                  uploadToggleBtn.addEventListener('click', function() {
                    if (designSectionWrapper.style.display === 'none') {
                      designSectionWrapper.style.display = 'block';
                      uploadToggleBtn.classList.add('active');
                      if (designNowBtn) designNowBtn.classList.remove('active');
                      
                      // Remove any global printing method section (duplicate)
                      const printLocationsSection = document.getElementById('printLocationsSection');
                      if (printLocationsSection) {
                        // Remove by class
                        const globalPrintingMethod = printLocationsSection.querySelector('.printing-method-section');
                        if (globalPrintingMethod && !globalPrintingMethod.closest('.print-location-card')) {
                          globalPrintingMethod.remove();
                        }
                        // Also check for any element containing "Select Printing Method" text that's not in a location card
                        const allElements = printLocationsSection.querySelectorAll('*');
                        allElements.forEach(el => {
                          if (el.textContent && el.textContent.includes('Select Printing Method') && !el.closest('.print-location-card')) {
                            // Check if this is a heading or container for printing method options
                            const hasPrintingOptions = el.querySelector('.printing-method-options') || 
                                                      el.nextElementSibling?.classList.contains('printing-method-options') ||
                                                      el.parentElement?.querySelector('.printing-method-options');
                            if (hasPrintingOptions) {
                              const container = el.closest('.printing-method-section') || el.parentElement;
                              if (container && !container.closest('.print-location-card')) {
                                container.remove();
                              }
                            }
                          }
                        });
                      }
                      
                      // Auto-add first location on first open
                      if (isFirstOpen && addBtn && !document.getElementById('eaSpotPicker')) {
                        isFirstOpen = false;
                        setTimeout(() => addBtn.click(), 100);
                      }
                    } else {
                      designSectionWrapper.style.display = 'none';
                      uploadToggleBtn.classList.remove('active');
                    }
                  });
                }
                
                // Also remove on page load and after a short delay to catch dynamically created elements
                function removeGlobalPrintingMethod() {
                  const printLocationsSection = document.getElementById('printLocationsSection');
                  const designSectionWrapperEl = document.getElementById('designSectionWrapper');
                  
                  // Check both printLocationsSection and designSectionWrapper
                  const containersToCheck = [printLocationsSection, designSectionWrapperEl].filter(Boolean);
                  
                  containersToCheck.forEach(container => {
                    if (!container) return;
                    
                    // Remove by class - any printing-method-section that's not inside a location card
                    const allPrintingMethodSections = container.querySelectorAll('.printing-method-section');
                    allPrintingMethodSections.forEach(section => {
                      if (!section.closest('.print-location-card')) {
                        section.remove();
                      }
                    });
                    
                    // Also check for any element containing "Select Printing Method" text that's not in a location card
                    const allElements = container.querySelectorAll('*');
                    allElements.forEach(el => {
                      const text = el.textContent || '';
                      // Check if this element or its children contain "Select Printing Method"
                      if (text.includes('Select Printing Method') && !el.closest('.print-location-card')) {
                        // Find the parent container that has printing method options
                        let containerToRemove = el;
                        let foundOptions = false;
                        
                        // Check if this element or nearby elements have printing-method-options
                        if (el.querySelector('.printing-method-options')) {
                          foundOptions = true;
                        } else if (el.nextElementSibling?.classList.contains('printing-method-options')) {
                          foundOptions = true;
                          containerToRemove = el.parentElement;
                        } else if (el.parentElement?.querySelector('.printing-method-options')) {
                          foundOptions = true;
                          containerToRemove = el.parentElement;
                        } else {
                          // Check siblings
                          let sibling = el.nextElementSibling;
                          while (sibling && !foundOptions) {
                            if (sibling.classList.contains('printing-method-options') || sibling.querySelector('.printing-method-options')) {
                              foundOptions = true;
                              containerToRemove = el.parentElement || container;
                            }
                            sibling = sibling.nextElementSibling;
                          }
                        }
                        
                        if (foundOptions && containerToRemove && !containerToRemove.closest('.print-location-card')) {
                          containerToRemove.remove();
                        } else if (!foundOptions && (el.tagName === 'H3' || el.tagName === 'H2' || el.tagName === 'H4' || el.tagName === 'LABEL')) {
                          // If it's a heading/label with "Select Printing Method", check if it's part of a printing method section
                          const parent = el.parentElement;
                          if (parent && (parent.classList.contains('printing-method-section') || parent.querySelector('.printing-method-options')) && !parent.closest('.print-location-card')) {
                            parent.remove();
                          } else if (!el.closest('.print-location-card')) {
                            // Just remove the heading/label itself if it's not in a location card
                            el.remove();
                          }
                        }
                      }
                    });
                    
                    // Also check for direct children that might be printing method sections
                    Array.from(container.children).forEach(child => {
                      if (child.classList.contains('printing-method-section') || 
                          (child.textContent && child.textContent.includes('Select Printing Method') && 
                           !child.closest('.print-location-card'))) {
                        child.remove();
                      }
                    });
                  });
                }
                
                // Run on page load
                removeGlobalPrintingMethod();
                
                // Also run after delays to catch dynamically created elements
                setTimeout(removeGlobalPrintingMethod, 100);
                setTimeout(removeGlobalPrintingMethod, 500);
                setTimeout(removeGlobalPrintingMethod, 1000);
                setTimeout(removeGlobalPrintingMethod, 2000);
                
                // Use MutationObserver to watch for dynamically added elements
                const printLocationsSectionObs = document.getElementById('printLocationsSection');
                const designSectionWrapperObs = document.getElementById('designSectionWrapper');
                
                if (printLocationsSectionObs || designSectionWrapperObs) {
                  const observer = new MutationObserver(function(mutations) {
                    removeGlobalPrintingMethod();
                  });
                  
                  const targetNodes = [printLocationsSectionObs, designSectionWrapperObs].filter(Boolean);
                  targetNodes.forEach(node => {
                    observer.observe(node, {
                      childList: true,
                      subtree: true
                    });
                  });
                }
                
                // Design Now Modal
                const designModal = document.getElementById('designModal');
                const designModalClose = document.getElementById('designModalClose');
                const designModalOk = document.getElementById('designModalOk');
                
                function openDesignModal() {
                  // The upload + placement design tool (assets/ea-design-tool.js)
                  if (window.EADesignTool && window.EADesignTool.open()) {
                    if (uploadToggleBtn && designSectionWrapper) {
                      uploadToggleBtn.classList.remove('active');
                      designSectionWrapper.style.display = 'none';
                    }
                    return;
                  }
                  // No print areas for this product: fall back to the manual print-location builder
                  if (!designModal && uploadToggleBtn) {
                    if (designSectionWrapper && designSectionWrapper.style.display === 'none') uploadToggleBtn.click();
                    return;
                  }
                  if (designNowBtn) {
                    designNowBtn.classList.add('active');
                  }
                  if (uploadToggleBtn && designSectionWrapper) {
                    uploadToggleBtn.classList.remove('active');
                    designSectionWrapper.style.display = 'none';
                  }
                  if (designModal) {
                    designModal.style.display = 'flex';
                  }
                }
                
                function closeDesignModal() {
                  if (designNowBtn) {
                    designNowBtn.classList.remove('active');
                  }
                  if (designModal) {
                    designModal.style.display = 'none';
                  }
                }
                
                if (designNowBtn) {
                  designNowBtn.addEventListener('click', openDesignModal);
                }
                
                if (designModalClose) {
                  designModalClose.addEventListener('click', closeDesignModal);
                }
                
                if (designModalOk) {
                  designModalOk.addEventListener('click', closeDesignModal);
                }
                
                // Close modal when clicking outside
                if (designModal) {
                  designModal.addEventListener('click', function(e) {
                    if (e.target === designModal) {
                      closeDesignModal();
                    }
                  });
                }
                
                // Print Locations Functionality
                let locationCount = 0;
                const container = document.getElementById('print-locations-container');
                const productFormId = _cmpSectionId ? `product-form-${_cmpSectionId}` : 'product-form';
                
                // External placement thumbnail image used for all location previews.
                const PLACEMENT_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0740/1871/7987/files/Untitled_design_5.png?v=1767844945';
                // Start a single preload to capture intrinsic aspect ratio for precise sizing.
                if (!window._placementImagePreloadStarted && typeof PLACEMENT_IMAGE_URL === 'string' && PLACEMENT_IMAGE_URL.length) {
                  window._placementImagePreloadStarted = true;
                  try {
                    const _preImg = new Image();
                    _preImg.crossOrigin = 'anonymous';
                    _preImg.onload = function() {
                      try { window._placementImageAspect = _preImg.naturalWidth / _preImg.naturalHeight; } catch (e) { window._placementImageAspect = null; }
                      // After we know the aspect ratio, re-render thumbnails (may still need the embedded data URI).
                      try { reRenderPlacementThumbnails(); } catch (e) { /* silent */ }
                    };
                    _preImg.onerror = function() { window._placementImageAspect = null; };
                    _preImg.src = PLACEMENT_IMAGE_URL;

                    // Also fetch the image as a blob and convert to data URI so embedded SVGs can include the PNG inline.
                    // This avoids cross-origin blocking when the SVG is used as an <img src="data:image/svg+xml,...">.
                    try {
                      fetch(PLACEMENT_IMAGE_URL, { mode: 'cors' }).then(resp => {
                        if (!resp.ok) throw new Error('Failed to fetch image');
                        return resp.blob();
                      }).then(blob => {
                        const reader = new FileReader();
                        reader.onload = function(e) {
                          try { window._placementImageDataURI = e.target.result; } catch (err) { window._placementImageDataURI = null; }
                          // Re-render thumbnails now that we have an embedded data URI
                          try { reRenderPlacementThumbnails(); } catch (e) { /* silent */ }
                        };
                        reader.onerror = function() {
                          window._placementImageDataURI = null;
                        };
                        reader.readAsDataURL(blob);
                      }).catch(() => {
                        window._placementImageDataURI = null;
                      });
                    } catch (e) {
                      window._placementImageDataURI = null;
                    }
                  } catch (e) {
                    window._placementImageAspect = null;
                  }
                }

                // Re-render all existing placement thumbnail <img> elements using the latest aspect ratio.
                // This updates any thumbnails that were generated before the preload completed.
                function reRenderPlacementThumbnails() {
                  // Find label images inside any location spots grid or print location card
                  const imgs = document.querySelectorAll('.location-spots-grid label img, .print-location-card label img, .location-spots-grid img');
                  imgs.forEach(img => {
                    try {
                      const label = img.closest('label');
                      if (!label) return;
                      // Find associated input via for/id relationship
                      const forAttr = label.getAttribute('for');
                      let input = null;
                      if (forAttr) input = document.getElementById(forAttr);
                      // Fallback: look for input inside the label
                      if (!input) input = label.querySelector('input[type="radio"], input[type="checkbox"]');
                      if (!input) return;
                      const locationValue = input.value;
                      // Determine view: try to find nearest area select (e.g., 'Front'/'Back' selector)
                      let view = 'front';
                      const areaSelect = img.closest('.print-location-card') ? img.closest('.print-location-card').querySelector('select.area-select') : null;
                      if (areaSelect) view = areaSelect.value || 'front';
                      // Generate fresh SVG and set as src
                      img.src = (window.__CMP_BUILDER_CONFIG && window.__CMP_BUILDER_CONFIG.profile === 'hats_beanies')
                        ? generateHatPlacementSVG(locationValue)
                        : generatePrintLocationSVG(locationValue, view);
                    } catch (e) {
                      // don't block other images on error
                    }
                  });
                }
                
                // Garment drawings + placement areas live in assets/ea-print-placements.js
                // (shared with the cart "Add customisation" pop-up).
                function generatePrintLocationSVG(location, view) {
                  return window.EAPrintPlacements ? window.EAPrintPlacements.svg(location, view) : '';
                }

                function getHeadwearStyle() {
                  const s = window.__CMP_BUILDER_CONFIG && window.__CMP_BUILDER_CONFIG.headwearStyle;
                  return s === 'beanie' ? 'beanie' : 'cap';
                }

                /** Hats & beanies embroidery placement thumbnails (cap or beanie silhouette). */
                function generateHatPlacementSVG(location) {
                  const style = getHeadwearStyle();
                  const svgW = 120;
                  const svgH = 140;
                  const baseColor = '#333333';
                  const highlightColor = '#3b82f6';
                  const highlightStroke = '#2563eb';
                  const logoFill = '#1d4ed8';
                  const logoBg = 'rgba(147,197,253,0.45)';

                  const labels = {
                    'Hat Center Front': 'Center front',
                    'Hat Side Temple': 'Side (temple)',
                    'Front Centre Logo': 'Front centre',
                    'Full Crown Front': 'Full crown',
                    'Left Temple': 'Left temple',
                    'Right Temple': 'Right temple',
                    'Centre Back Arch': 'Centre back',
                    'Full Back Panel': 'Full back',
                    'Bill Front Small': 'Bill front',
                    'Bill Full Width': 'Full bill'
                  };

                  function logoMark(cx, cy, w, h) {
                    return (
                      '<rect x="' +
                      (cx - w / 2) +
                      '" y="' +
                      (cy - h / 2) +
                      '" width="' +
                      w +
                      '" height="' +
                      h +
                      '" rx="1.6" fill="' +
                      logoBg +
                      '" stroke="' +
                      highlightStroke +
                      '" stroke-width="0.55"/>' +
                      '<text x="' +
                      cx +
                      '" y="' +
                      (cy + 1.1) +
                      '" font-family="Arial,sans-serif" font-size="3.4" font-weight="700" fill="' +
                      logoFill +
                      '" text-anchor="middle">ea</text>'
                    );
                  }

                  function capFrontCenter() {
                    const crown =
                      '<ellipse cx="60" cy="44" rx="40" ry="24" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="2"/>';
                    const bill =
                      '<path d="M 24 56 Q 60 66 96 56 L 100 74 Q 60 86 20 74 Z" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="2" stroke-linejoin="round"/>';
                    const hi =
                      '<rect x="50" y="32" width="20" height="16" rx="3" fill="' +
                      highlightColor +
                      '" opacity="0.22" stroke="' +
                      highlightStroke +
                      '" stroke-width="1.35"/>';
                    return crown + bill + hi + logoMark(60, 40, 12, 7);
                  }

                  function capSideTemple() {
                    const dome =
                      '<path d="M 30 82 Q 36 34 86 40 Q 106 46 100 82" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="2" stroke-linecap="round"/>';
                    const bill =
                      '<path d="M 36 80 L 40 100 L 92 96 Q 68 86 36 80" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="2" stroke-linejoin="round"/>';
                    const hi =
                      '<rect x="22" y="46" width="14" height="20" rx="3" fill="' +
                      highlightColor +
                      '" opacity="0.22" stroke="' +
                      highlightStroke +
                      '" stroke-width="1.25" transform="rotate(-14 29 56)"/>';
                    return dome + bill + hi + logoMark(29, 56, 10, 6);
                  }

                  function beanieFrontCenter() {
                    const dome =
                      '<path d="M 22 72 Q 24 28 60 22 Q 96 28 98 72" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="2" stroke-linecap="round"/>';
                    const band =
                      '<path d="M 22 72 Q 60 80 98 72" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="1.7"/>';
                    const hi =
                      '<rect x="50" y="36" width="20" height="16" rx="3" fill="' +
                      highlightColor +
                      '" opacity="0.22" stroke="' +
                      highlightStroke +
                      '" stroke-width="1.35"/>';
                    return dome + band + hi + logoMark(60, 44, 12, 7);
                  }

                  function beanieSideTemple() {
                    const dome =
                      '<path d="M 32 80 Q 38 34 78 40 Q 102 48 98 80" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="2"/>';
                    const band =
                      '<path d="M 34 80 Q 66 86 96 80" fill="none" stroke="' +
                      baseColor +
                      '" stroke-width="1.6"/>';
                    const hi =
                      '<rect x="26" y="46" width="12" height="18" rx="2.5" fill="' +
                      highlightColor +
                      '" opacity="0.22" stroke="' +
                      highlightStroke +
                      '" stroke-width="1.2" transform="rotate(-10 32 55)"/>';
                    return dome + band + hi + logoMark(32, 54, 9, 6);
                  }

                  let art = '';
                  const displayLabel = labels[location] || location;

                  const centerKeys = ['Hat Center Front', 'Front Centre Logo', 'Full Crown Front', 'Centre Back Arch', 'Full Back Panel'];
                  const sideKeys = ['Hat Side Temple', 'Left Temple', 'Right Temple', 'Bill Front Small', 'Bill Full Width'];

                  if (centerKeys.indexOf(location) !== -1) {
                    art = style === 'beanie' ? beanieFrontCenter() : capFrontCenter();
                  } else if (sideKeys.indexOf(location) !== -1) {
                    art = style === 'beanie' ? beanieSideTemple() : capSideTemple();
                  } else {
                    art = style === 'beanie' ? beanieFrontCenter() : capFrontCenter();
                  }

                  const svg =
                    '<svg width="' +
                    svgW +
                    '" height="' +
                    svgH +
                    '" viewBox="0 0 ' +
                    svgW +
                    ' ' +
                    svgH +
                    '" xmlns="http://www.w3.org/2000/svg">' +
                    art +
                    '<text x="60" y="128" font-family="Arial, sans-serif" font-size="10" font-weight="600" fill="' +
                    baseColor +
                    '" text-anchor="middle">' +
                    cmpEscapeHtml(displayLabel) +
                    '</text></svg>';
                  return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
                }
                
                // Print location options with SVG illustrations - organised into default and advanced
                const APPAREL_PRINT_LOCATIONS = {
                  'Front': {
                    default: [
                      { value: 'Front Left Chest', label: 'Left Chest', img: generatePrintLocationSVG('Front Left Chest', 'front') },
                      { value: 'Center Front', label: 'Centre Chest', img: generatePrintLocationSVG('Center Front', 'front') },
                      { value: 'Full Front', label: 'Full Front', img: generatePrintLocationSVG('Full Front', 'front') }
                    ],
                    advanced: [
                      { value: 'Front Right Chest', label: 'Right Chest', img: generatePrintLocationSVG('Front Right Chest', 'front') },
                      { value: 'Over Pocket', label: 'Over Pocket', img: generatePrintLocationSVG('Over Pocket', 'front') },
                      { value: 'Lower Front', label: 'Lower Front', img: generatePrintLocationSVG('Lower Front', 'front') },
                      { value: 'Lower Left', label: 'Lower Left', img: generatePrintLocationSVG('Lower Left', 'front') },
                      { value: 'Lower Right', label: 'Lower Right', img: generatePrintLocationSVG('Lower Right', 'front') },
                      { value: 'Vertical Left', label: 'Vertical Left', img: generatePrintLocationSVG('Vertical Left', 'front') },
                      { value: 'Vertical Right', label: 'Vertical Right', img: generatePrintLocationSVG('Vertical Right', 'front') }
                    ]
                  },
                  'Back': {
                    default: [
                      { value: 'Top Back', label: 'Upper Back', img: generatePrintLocationSVG('Top Back', 'back') },
                      { value: 'Center Back', label: 'Full Back', img: generatePrintLocationSVG('Center Back', 'back') }
                    ],
                    advanced: [
                      { value: 'Lower Back', label: 'Lower Back', img: generatePrintLocationSVG('Lower Back', 'back') },
                      { value: 'Vertical Back L', label: 'Vertical Left', img: generatePrintLocationSVG('Vertical Back L', 'back') },
                      { value: 'Vertical Back R', label: 'Vertical Right', img: generatePrintLocationSVG('Vertical Back R', 'back') }
                    ]
                  },
                  'Sleeves': {
                    default: [
                      { value: 'Left Sleeve', label: 'Left Sleeve', img: generatePrintLocationSVG('Left Sleeve', 'front') },
                      { value: 'Right Sleeve', label: 'Right Sleeve', img: generatePrintLocationSVG('Right Sleeve', 'front') }
                    ],
                    advanced: []
                  },
                  'Sides': {
                    default: [
                      { value: 'Left Side', label: 'Left Side', img: generatePrintLocationSVG('Left Side', 'front') },
                      { value: 'Right Side', label: 'Right Side', img: generatePrintLocationSVG('Right Side', 'front') }
                    ],
                    advanced: []
                  }
                };

                const HATS_PRINT_LOCATIONS = {
                  'Embroidery placement': {
                    default: [
                      {
                        value: 'Hat Center Front',
                        label: 'Center front',
                        img: generateHatPlacementSVG('Hat Center Front')
                      },
                      {
                        value: 'Hat Side Temple',
                        label: 'Side (temple)',
                        img: generateHatPlacementSVG('Hat Side Temple')
                      }
                    ],
                    advanced: []
                  }
                };

                let printLocations = cmpBuilderConfig.profile === 'hats_beanies' ? HATS_PRINT_LOCATIONS : APPAREL_PRINT_LOCATIONS;
                // Only offer print positions Tapstitch can print on this blank (sleeves/sides per product)
                if (printLocations === APPAREL_PRINT_LOCATIONS && window.EAPrintPlacements && window.EAPrintPlacements.allowedAreaIds) {
                  const handleMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
                  const allowed = window.EAPrintPlacements.allowedAreaIds(handleMatch ? decodeURIComponent(handleMatch[1]) : '');
                  printLocations = Object.fromEntries(Object.entries(printLocations).filter(([area]) => allowed.includes(area)));
                }

                function cmpEscapeHtml(str) {
                  return String(str)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/"/g, '&quot;');
                }

                function createLocationCard() {
                  locationCount++;
                  const locationId = `location-${locationCount}`;
                  
                  const card = document.createElement('div');
                  card.className = 'print-location-card';
                  card.id = locationId;

                  const isHatsProfile = window.__CMP_BUILDER_CONFIG && window.__CMP_BUILDER_CONFIG.profile === 'hats_beanies';
                  const locationHeaderLabel = isHatsProfile ? 'Decoration location' : 'Print location';
                  const methodFieldLabel = isHatsProfile ? 'Decoration method' : 'Printing method';
                  const areaFieldLabel = isHatsProfile ? 'Placement zone' : 'Select area';
                  const embBulkMinUnits = cmpEmbroideryBulkMin();
                  const areaOptionsHtml = ['<option value="">Choose area...</option>']
                    .concat(Object.keys(printLocations).map(function (area) {
                      return '<option value="' + cmpEscapeHtml(area) + '">' + cmpEscapeHtml(area) + '</option>';
                    }))
                    .join('');

                  const printingMethodBlock = isHatsProfile
                    ? `
                    <div class="location-printing-method-selector location-printing-method-selector--embroidery-only">
                      <label class="location-printing-method-selector__label">${methodFieldLabel}</label>
                      <div class="printing-method-options printing-method-options--embroidery-only">
                        <label class="printing-method-option">
                          <input type="radio"
                                 name="properties[${locationId}_printing_method]"
                                 value="Embroidery"
                                 id="${locationId}-method-embroidery"
                                 form="${productFormId}"
                                 checked>
                          <div class="method-card">
                            <span class="method-banner method-banner-premium">Embroidery</span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                              <path d="M20.5 3.5 6 18l-2 2.5L6.5 18.5"/>
                              <ellipse cx="18.6" cy="5.4" rx="1.6" ry="0.7" transform="rotate(-45 18.6 5.4)"/>
                              <path d="M18.6 5.4c-4.5-2.2-8.6 1.6-5.6 4.6s1.5 7.4-4.4 7.1"/>
                            </svg>
                            <div class="method-name-wrapper">
                              <span class="method-name">Embroidery only</span>
                              <span class="embroidery-moq-badge">MOQ ${embBulkMinUnits} units</span>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>`
                    : `
                    <div class="location-printing-method-selector">
                      <label class="location-printing-method-selector__label">${methodFieldLabel}:</label>
                      <div class="printing-method-options">
                        <label class="printing-method-option">
                          <input type="radio"
                                 name="properties[${locationId}_printing_method]"
                                 value="Digital Print"
                                 id="${locationId}-method-digital-print"
                                 form="${productFormId}"
                                 checked>
                          <div class="method-card">
                            <span class="method-banner method-banner-cost-effective">Cost Effective</span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                              <path d="M7 9V3.5h10V9"/>
                              <rect x="3" y="9" width="18" height="8" rx="2"/>
                              <path d="M7 14h10v6.5H7z"/>
                              <circle cx="17.5" cy="12" r="0.4" fill="currentColor"/>
                            </svg>
                            <span class="method-name">Digital Print</span>
                          </div>
                        </label>

                        <label class="printing-method-option">
                          <input type="radio"
                                 name="properties[${locationId}_printing_method]"
                                 value="Embroidery"
                                 id="${locationId}-method-embroidery"
                                 form="${productFormId}">
                          <div class="method-card">
                            <span class="method-banner method-banner-premium">Premium</span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                              <path d="M20.5 3.5 6 18l-2 2.5L6.5 18.5"/>
                              <ellipse cx="18.6" cy="5.4" rx="1.6" ry="0.7" transform="rotate(-45 18.6 5.4)"/>
                              <path d="M18.6 5.4c-4.5-2.2-8.6 1.6-5.6 4.6s1.5 7.4-4.4 7.1"/>
                            </svg>
                            <div class="method-name-wrapper">
                              <span class="method-name">Embroidery</span>
                              <span class="embroidery-moq-badge">MOQ ${embBulkMinUnits} units</span>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>`;
                  
                  card.innerHTML = `
                    <div class="location-header">
                      <span class="location-number">${locationHeaderLabel} #${container.querySelectorAll('.print-location-card').length + 1}</span>
                      <button type="button" class="remove-location-btn" onclick="removeLocation('${locationId}')">Remove</button>
                    </div>
                    
                    ${printingMethodBlock}
                    
                    <div class="location-spot-selector">
                      <label class="area-field-label">${areaFieldLabel}:</label>
                      <select class="area-select" onchange="updateSpotOptions('${locationId}', this.value)" style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 6px; font-size: 0.95em;">
                        ${areaOptionsHtml}
                      </select>
                      
                      <div class="location-spots-grid" id="${locationId}-spots"></div>
                    </div>
                    
                    <div class="file-upload-section" id="${locationId}-upload">
                      <label class="file-upload-label">Upload Artwork:</label>
                      <div class="file-input-wrapper">
                        <input type="file" 
                               name="properties[${locationId}_artwork]" 
                               accept="image/*,.pdf,.ai"
                               form="${productFormId}"
                               onchange="handleFileUpload('${locationId}', this)">
                      </div>
                      <div class="file-preview" id="${locationId}-preview"></div>
                    </div>
                  `;
                  
                  
                  container.appendChild(card);

                  if (isHatsProfile) {
                    card.classList.add('print-location-card--hats');
                  }

                  const placementKeys = Object.keys(printLocations);
                  const areaSelectInit = card.querySelector('select.area-select');
                  const spotSelectorWrap = card.querySelector('.location-spot-selector');
                  if (areaSelectInit && placementKeys.length === 1) {
                    if (spotSelectorWrap) spotSelectorWrap.classList.add('location-spot-selector--single-area');
                    areaSelectInit.value = placementKeys[0];
                    if (typeof window.updateSpotOptions === 'function') {
                      window.updateSpotOptions(locationId, placementKeys[0]);
                    }
                  }
                  
                  // Helper function to update variant IDs on spot inputs when method changes
                  const updateSpotVariantIds = function(card) {
                    const methodInput = card.querySelector('input[name*="_printing_method"]:checked');
                    if (!methodInput) return;
                    
                    const method = methodInput.value;
                    if (method !== 'Digital Print' && method !== 'Embroidery') return;
                    
                    // Update all spot inputs in this card with variant IDs
                    const spotInputs = card.querySelectorAll('input[name*="_spot"]');
                    spotInputs.forEach(spotInput => {
                      const size = spotInput.dataset.locationSize || getLocationSize(spotInput.value);
                      const variantId = CUSTOMISATION_VARIANTS[method]?.[size];
                      if (variantId) {
                        spotInput.dataset.customisationVariantId = variantId;
                        spotInput.dataset.customisationMethod = method;
                        spotInput.dataset.customisationSize = size;
                      }
                    });
                  };
                  
                  // Add event listeners for printing method changes to update MOQ and pricing
                  const printingMethodInputs = card.querySelectorAll('input[type="radio"][name*="_printing_method"]');
                  printingMethodInputs.forEach(input => {
                    input.addEventListener('change', function() {
                      updateMOQBasedOnPrintingMethods();
                      // Update variant IDs on spot inputs
                      updateSpotVariantIds(card);
                      // Trigger price summary update
                      if (window.recalculatePricing) {
                        window.recalculatePricing();
                      }
                      // Also update the volume discount pricing table
                      if (window.updateDisplays && window.getSliderQuantity) {
                        const currentQty = window.getSliderQuantity();
                        window.updateDisplays(currentQty);
                      }
                    });
                  });
                  
                  // Update variant IDs when spot options are first rendered
                  requestAnimationFrame(() => {
                    updateSpotVariantIds(card);
                  });
                  
                  // Add event listener for spot selection changes to update pricing
                  // Use event delegation on the card to handle dynamically added spot inputs
                  card.addEventListener('change', function(e) {
                    if (e.target.name && e.target.name.includes('_spot')) {
                      // Update variant ID for this spot input
                      const methodInput = card.querySelector('input[name*="_printing_method"]:checked');
                      if (methodInput) {
                        const method = methodInput.value;
                        const size = e.target.dataset.locationSize || getLocationSize(e.target.value);
                        const variantId = CUSTOMISATION_VARIANTS[method]?.[size];
                        if (variantId) {
                          e.target.dataset.customisationVariantId = variantId;
                          e.target.dataset.customisationMethod = method;
                          e.target.dataset.customisationSize = size;
                        }
                      }
                      // Trigger price summary update
                      if (window.recalculatePricing) {
                        window.recalculatePricing();
                      }
                      // Also update the volume discount pricing table
                      if (window.updateDisplays && window.getSliderQuantity) {
                        const currentQty = window.getSliderQuantity();
                        window.updateDisplays(currentQty);
                      }
                    }
                  });
                  
                  // Remove any global printing method section after adding location card
                  removeGlobalPrintingMethod();
                  
                  // Update MOQ immediately after creating location card (no delay)
                  // Use requestAnimationFrame to ensure DOM is ready
                  requestAnimationFrame(() => {
                    updateMOQBasedOnPrintingMethods();
                  });
                  
                  // On touch devices (mobile), replace the native select with a tiny custom dropdown
                  // to avoid the browser opening the native popover positioned above the element.
                  // This keeps the options anchored in the page and avoids surprising positioning.
                  try {
                    if (typeof isTouchDevice === 'function' && isTouchDevice() && window.matchMedia('(max-width: 768px)').matches) {
                      const selects = card.querySelectorAll('select.area-select');
                      selects.forEach(s => {
                        try { createCustomSelect(s); } catch (e) { /* fail-safe: ignore */ }
                      });
                    }
                  } catch (e) {
                    // defensive: do not break creation flow if helper not available yet
                    // createCustomSelect is appended later in this file and will be available in most cases
                  }
                }
                
                // Centralized function to calculate printing method MOQ (single source of truth)
                // Returns: { moq: number, hasEmbroidery: boolean }
                window.getPrintingMethodMOQ = function() {
                  const allPrintingMethods = document.querySelectorAll('input[name*="_printing_method"]:checked');
                  let hasEmbroidery = false;

                  allPrintingMethods.forEach(input => {
                    if (input && (input.value === 'Embroidery' || String(input.value).toLowerCase().includes('embroidery'))) {
                      hasEmbroidery = true;
                    }
                  });

                  // Digital Print = MOQ 1, Embroidery = MOQ 1
                  const requiredMOQ = 1;
                  return { moq: requiredMOQ, hasEmbroidery: hasEmbroidery };
                };

                // Centralized function to enforce printing method MOQ on slider
                // This is called from multiple places to ensure consistency.
                // It will set the slider's min and (if needed) snap the value to the required MOQ,
                // then synchronously ensure the rest of the UI stays in sync.
                window.enforcePrintingMethodMOQ = function() {
                  const moqData = window.getPrintingMethodMOQ();
                  const requiredMOQ = moqData.moq;
                  const slider = document.getElementById('volume-quantity-slider');
                  
                  if (!slider) return false;

                  // Always set the min attribute to the required MOQ (both property and attribute)
                  try {
                    slider.min = String(requiredMOQ);
                    slider.setAttribute('min', String(requiredMOQ));
                  } catch (e) {
                    console.warn('Failed to set slider min:', e);
                    return false;
                  }

                  // Read current value robustly (use canonical getter to avoid offsets)
                  let currentValue = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : Number.parseInt(slider.value, 10);
                  if (Number.isNaN(currentValue) || currentValue < 1) {
                    currentValue = 0;
                  }

                  // If current value is below the required MOQ, snap it to MOQ
                  if (currentValue < requiredMOQ) {
                    slider.value = String(requiredMOQ);
                    try { slider.setAttribute('value', String(requiredMOQ)); } catch (e) {}

                    // Try to synchronously update the UI to avoid transient mismatch between
                    // the visible thumb and the displayed quantity. Prefer calling any
                    // central update function if present; otherwise dispatch an input event.
                    if (typeof window.updateDisplays === 'function') {
                      try {
                        window.updateDisplays(requiredMOQ);
                      } catch (e) {
                        // Fallback to dispatching input event if updateDisplays fails
                        slider.dispatchEvent(new Event('input', { bubbles: true }));
                      }
                    } else {
                      slider.dispatchEvent(new Event('input', { bubbles: true }));
                    }

                    // Also update quantity tracker and pricing to be safe
                    if (typeof window.updateQuantityTracker === 'function') {
                      try { window.updateQuantityTracker(); } catch (e) {}
                    }
                    if (typeof window.recalculatePricing === 'function') {
                      try { window.recalculatePricing(); } catch (e) {}
                    }

                    // Dispatch change as well to notify any listeners that read value/attributes
                    try { slider.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}

                    return true; // Indicates value was changed
                  }

                  return false; // No change needed
                };

                // Function to calculate MOQ based on selected printing methods
                function updateMOQBasedOnPrintingMethods() {
                  const moqData = window.getPrintingMethodMOQ();
                  const requiredMOQ = moqData.moq;
                  const hasEmbroidery = moqData.hasEmbroidery;

                  // Enforce MOQ on slider (this handles min and value snapping)
                  window.enforcePrintingMethodMOQ();

                  // Additionally make sure slider.value is at least the required MOQ and that
                  // the visible thumb + displayed quantity are synchronised immediately.
                  const slider = document.getElementById('volume-quantity-slider');
                  if (slider) {
                    const cur = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : Number.parseInt(slider.value, 10) || 0;
                    let newVal = Math.max(cur, requiredMOQ);
                    const embBulkMin = cmpEmbroideryBulkMin();
                    
                    // If embroidery is selected, bump quantity up to the embroidery bulk minimum when below threshold
                    if (hasEmbroidery && cur <= embBulkMin - 1) {
                      newVal = embBulkMin;
                    }
                    
                    if (cur !== newVal) {
                      slider.value = String(newVal);
                      
                      // Prefer calling central update function if available to update UI synchronously.
                      if (typeof window.updateDisplays === 'function') {
                        try { window.updateDisplays(newVal); } catch (e) { slider.dispatchEvent(new Event('input', { bubbles: true })); }
                      } else {
                        slider.dispatchEvent(new Event('input', { bubbles: true }));
                      }
                      
                      // Also update quantity tracker and pricing
                      if (typeof window.updateQuantityTracker === 'function') {
                        try { window.updateQuantityTracker(); } catch (e) {}
                      }
                      if (typeof window.recalculatePricing === 'function') {
                        try { window.recalculatePricing(); } catch (e) {}
                      }
                      
                      // Dispatch change event to notify listeners
                      try { slider.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
                    } else {
                      // Even if value didn't change, ensure UI is synced
                      if (typeof window.updateDisplays === 'function') {
                        try { window.updateDisplays(newVal); } catch (e) { slider.dispatchEvent(new Event('input', { bubbles: true })); }
                      } else {
                        slider.dispatchEvent(new Event('input', { bubbles: true }));
                      }
                    }
                  }

                  // Update delivery method MOQ badges (inline next to info icon)
                  const expressMOQBadge = document.querySelector('.express-moq-badge');
                  if (expressMOQBadge) {
                    const embBulkMin = cmpEmbroideryBulkMin();
                    const displayMOQ = hasEmbroidery ? embBulkMin : requiredMOQ;
                    expressMOQBadge.textContent = `MOQ ${displayMOQ} units`;
                    expressMOQBadge.style.display = displayMOQ > 0 ? '' : 'none';
                  }

                  // Notify other parts of the UI that printing-method-based MOQ changed
                  document.dispatchEvent(new CustomEvent('printingMethodMOQChanged', {
                    detail: { moq: requiredMOQ, hasEmbroidery: hasEmbroidery }
                  }));

                  // Trigger pricing recalculation so totals/targets stay in sync
                  if (window.recalculatePricing) {
                    window.recalculatePricing();
                  }
                }
                
                // Initialize MOQ on page load - run immediately when DOM is ready
                // Use requestAnimationFrame to ensure DOM is fully rendered
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', function() {
                    requestAnimationFrame(() => {
                      updateMOQBasedOnPrintingMethods();
                    });
                  });
                } else {
                  // DOM already loaded
                  requestAnimationFrame(() => {
                    updateMOQBasedOnPrintingMethods();
                  });
                }
                
                // ============================================
                // PRICING ENGINE + SMART SAVER MOQ LOGIC
                // ============================================
                
                // Store product data globally for pricing calculations
                window._pricingProductData = null;
                window._pricingProductOptions = null;
                
                // Initialize product data for pricing
                function initializePricingData() {
                  const _variantsEl = document.querySelector('script[id^="custom-main-product-variants-data-"]');
                  const _optionsEl = document.querySelector('script[id^="custom-main-product-options-data-"]');
                  
                  try {
                    if (_variantsEl && _variantsEl.textContent) {
                      window._pricingProductData = JSON.parse(_variantsEl.textContent);
                    }
                  } catch (e) {
                    console.error('Error parsing product variants JSON for pricing:', e);
                  }
                  
                  try {
                    if (_optionsEl && _optionsEl.textContent) {
                      window._pricingProductOptions = JSON.parse(_optionsEl.textContent);
                    }
                  } catch (e) {
                    console.error('Error parsing product options JSON for pricing:', e);
                  }
                  
                  // Preload customisation variant prices
                  preloadCustomisationVariantPrices();
                }
                
                // Preload all customisation variant prices
                async function preloadCustomisationVariantPrices() {
                  if (!window._customisationVariantPrices) {
                    window._customisationVariantPrices = {};
                  }
                  
                  // Get all variant IDs from CUSTOMISATION_VARIANTS
                  const variantIdsToFetch = [];
                  Object.keys(CUSTOMISATION_VARIANTS).forEach(method => {
                    Object.keys(CUSTOMISATION_VARIANTS[method]).forEach(size => {
                      const variantId = CUSTOMISATION_VARIANTS[method][size];
                      if (variantId) {
                        // Use hardcoded price if available (immediate)
                        if (CUSTOMISATION_VARIANT_PRICES && CUSTOMISATION_VARIANT_PRICES[variantId]) {
                          window._customisationVariantPrices[variantId] = CUSTOMISATION_VARIANT_PRICES[variantId];
                          console.log(`[preloadCustomisationVariantPrices] Loaded hardcoded price for ${method} ${size} (${variantId}): ${CUSTOMISATION_VARIANT_PRICES[variantId]} cents`);
                        } else {
                          // Check if already in pricing data
                          if (window._pricingProductData) {
                            const variant = window._pricingProductData.find(pv => String(pv.id) === String(variantId));
                            if (variant && variant.price) {
                              window._customisationVariantPrices[variantId] = variant.price;
                              console.log(`[preloadCustomisationVariantPrices] Loaded price from product data for ${method} ${size} (${variantId}): ${variant.price} cents`);
                            } else {
                              // Need to fetch from API
                              variantIdsToFetch.push({ variantId, method, size });
                            }
                          } else {
                            // Need to fetch from API
                            variantIdsToFetch.push({ variantId, method, size });
                          }
                        }
                      }
                    });
                  });
                  
                  // Fetch remaining prices from Shopify API
                  if (variantIdsToFetch.length > 0) {
                    console.log(`[preloadCustomisationVariantPrices] Fetching ${variantIdsToFetch.length} variant prices from API...`);
                    const fetchPromises = variantIdsToFetch.map(({ variantId, method, size }) => {
                      return window.fetchCustomisationVariantPrice(variantId).then(price => {
                        if (price > 0) {
                          console.log(`[preloadCustomisationVariantPrices] Fetched price for ${method} ${size} (${variantId}): ${price} cents`);
                        }
                        return price;
                      }).catch(error => {
                        console.warn(`[preloadCustomisationVariantPrices] Failed to fetch price for ${method} ${size} (${variantId}):`, error);
                        return 0;
                      });
                    });
                    
                    await Promise.all(fetchPromises);
                    
                    // Trigger price recalculation after all prices are loaded
                    if (window.recalculatePricing) {
                      setTimeout(() => {
                        window.recalculatePricing();
                      }, 100);
                    }
                  }
                  
                  console.log('[preloadCustomisationVariantPrices] Loaded prices:', window._customisationVariantPrices);
                }
                
                // Get total quantity from grid inputs (single source of truth)
                window.getTotalQty = function() {
                  const gridInputs = document.querySelectorAll('#variantGridBody input[type="number"]');
                  let total = 0;
                  
                  if (gridInputs.length > 0) {
                    gridInputs.forEach(input => {
                      total += parseInt(input.value) || 0;
                    });
                  } else if (window.selectedColorSizes) {
                    // Fallback to box view
                    Object.values(window.selectedColorSizes).forEach(colorData => {
                      Object.values(colorData).forEach(sizeData => {
                        total += (sizeData.qty || sizeData.quantity || 0);
                      });
                    });
                  }
                  
                  return total;
                };
                
                // Get selected variants with quantities from grid
                window.getSelectedVariantsWithQty = function() {
                  const gridInputs = document.querySelectorAll('#variantGridBody input[type="number"]');
                  const variants = [];
                  
                  gridInputs.forEach(input => {
                    const qty = parseInt(input.value) || 0;
                    if (qty > 0 && input.dataset.variantId) {
                      variants.push({
                        variantId: input.dataset.variantId,
                        quantity: qty,
                        color: input.dataset.color,
                        size: input.dataset.size
                      });
                    }
                  });
                  
                  return variants;
                };
                
                // Get weight in grams for a variant
                window.getWeightGramsForVariant = function(variantId) {
                  if (!window._pricingProductData) {
                    initializePricingData();
                  }
                  
                  if (!window._pricingProductData) return 440; // Fallback TODO
                  
                  const variant = window._pricingProductData.find(v => String(v.id) === String(variantId));
                  if (!variant) return 440; // Fallback TODO
                  
                  // Shopify weight can be in grams or kg - check and convert
                  let weightGrams = 0;
                  
                  if (variant.weight) {
                    weightGrams = parseFloat(variant.weight);
                    // If weight seems too small (< 100), assume it's in kg and convert
                    if (weightGrams < 100) {
                      weightGrams = weightGrams * 1000;
                    }
                  }
                  
                  // Fallback to wrapper data attribute if available
                  if (!weightGrams || weightGrams === 0) {
                    const wrapper = document.querySelector('.volume-discount-slider-wrapper');
                    if (wrapper) {
                      const variantWeight = parseInt(wrapper.dataset.variantWeight) || 0;
                      const productWeight = parseInt(wrapper.dataset.productWeight) || 0;
                      const garmentWeight = parseInt(wrapper.dataset.garmentWeight) || 0;
                      weightGrams = garmentWeight || variantWeight || productWeight || 0;
                      
                      // Convert kg to grams if needed
                      if (weightGrams > 0 && weightGrams < 100) {
                        weightGrams = weightGrams * 1000;
                      }
                    }
                  }
                  
                  // Final fallback
                  if (!weightGrams || weightGrams === 0) {
                    const wrapper = document.querySelector('.volume-discount-slider-wrapper');
                    if (wrapper && wrapper.dataset.weightGramsDefault) {
                      weightGrams = parseInt(wrapper.dataset.weightGramsDefault);
                    } else {
                      weightGrams = 440; // TODO: Default fallback
                    }
                  }
                  
                  return weightGrams;
                };
                
                // Calculate Smart Saver MOQ based on 21kg (21000g)
                window.getSmartSaverMOQ = function(weightGrams) {
                  if (!weightGrams || weightGrams === 0) {
                    // Try to get weight from first selected variant
                    const variants = window.getSelectedVariantsWithQty();
                    if (variants.length > 0) {
                      weightGrams = window.getWeightGramsForVariant(variants[0].variantId);
                    } else {
                      weightGrams = 440; // Fallback TODO
                    }
                  }
                  
                  return Math.ceil(21000 / weightGrams);
                };
                
                // Get volume discount rate based on total quantity
                window.getVolumeDiscountRate = function(totalQty) {
                  // Deprecated: bulk discounts are now handled via absolute tier pricing.
                  // Keep function for compatibility but return 0.
                  return 0;
                };
                
                // Bulk rate mirrors the live Shopify automatic discounts (6+ 5%, 30+ 10%, 100+ 20%),
                // defined once in custom-main-product.liquid as window.eaBulkRate.
                const bulkRateFor = (qty) => (typeof window.eaBulkRate === 'function' ? window.eaBulkRate(qty) : 0);

                // Compute displayed pricing
                window.computeDisplayedPricing = function() {
                  const totalQty = window.getTotalQty();
                  const variants = window.getSelectedVariantsWithQty();
                  
                  if (variants.length === 0) {
                    return {
                      baseUnitPrice: 0,
                      unitPriceBeforeDiscount: 0,
                      unitPriceAfterVolume: 0,
                      unitPriceFinal: 0,
                      totalFinal: 0,
                      volumeDiscountRate: 0,
                      smartSaverDiscountRate: 0,
                      multiplier: 1.9,
                      originalUnitPrice: 0,
                      unitPriceAfterBulk: 0,
                      bulkDiscountRate: 0,
                      totalQty: 0,
                      customisationCostPerUnit: 0,
                      customisationCostTotal: 0,
                      hasCustomisations: false,
                      printingAddonsPerUnit: 0,
                      printingAddonsTotal: 0,
                      hasPrintingAddons: false
                    };
                  }
                  
                  // Get base variant price (use first selected variant, or weighted average)
                  let basePriceCents = 0;
                  let totalWeightedPrice = 0;
                  let totalWeightedQty = 0;
                  
                  variants.forEach(v => {
                    if (!window._pricingProductData) {
                      initializePricingData();
                    }
                    const variant = window._pricingProductData?.find(pv => String(pv.id) === String(v.variantId));
                    if (variant && variant.price) {
                      totalWeightedPrice += variant.price * v.quantity;
                      totalWeightedQty += v.quantity;
                    }
                  });
                  
                  if (totalWeightedQty > 0) {
                    basePriceCents = Math.round(totalWeightedPrice / totalWeightedQty);
                  } else if (variants.length > 0) {
                    // Fallback: use first variant price
                    const firstVariant = window._pricingProductData?.find(pv => String(pv.id) === String(variants[0].variantId));
                    basePriceCents = firstVariant?.price || 0;
                  }
                  
                  // Fallback to wrapper data if no variant price found
                  if (!basePriceCents || basePriceCents === 0) {
                    const wrapper = document.querySelector('.volume-discount-slider-wrapper');
                    if (wrapper) {
                      basePriceCents = parseInt(wrapper.dataset.productPrice) || 0;
                    }
                  }
                  
                  if (!basePriceCents || basePriceCents === 0) {
                    return {
                      baseUnitPrice: 0,
                      unitPriceBeforeDiscount: 0,
                      unitPriceAfterVolume: 0,
                      unitPriceFinal: 0,
                      totalFinal: 0,
                      volumeDiscountRate: 0,
                      smartSaverDiscountRate: 0,
                      multiplier: 1.9,
                      originalUnitPrice: 0,
                      unitPriceAfterBulk: 0,
                      bulkDiscountRate: 0,
                      totalQty: totalQty,
                      customisationCostPerUnit: 0,
                      customisationCostTotal: 0,
                      hasCustomisations: false,
                      printingAddonsPerUnit: 0,
                      printingAddonsTotal: 0,
                      hasPrintingAddons: false
                    };
                  }
                  
                  // basePriceCents is the weighted price of the variants actually going in the cart.
                  // Smart Saver variants are already priced at Standard x 0.85 in Shopify, so the only
                  // thing left to apply is the bulk discount Shopify applies at checkout.
                  const smartSaverRadio = document.getElementById('delivery-smart-saver');
                  const isSmartSaver = smartSaverRadio && smartSaverRadio.checked;
                  const smartSaverDiscountRate = isSmartSaver ? 0.15 : 0;

                  const bulkDiscountRate = bulkRateFor(totalQty);
                  const bulkUnitPrice = Math.round(basePriceCents * (1 - bulkDiscountRate));
                  const unitPriceFinal = bulkUnitPrice;
                  const totalFinal = Math.round(basePriceCents * totalQty * (1 - bulkDiscountRate));

                  // Get Smart Saver MOQ
                  let smartSaverMOQ = 0;
                  if (isSmartSaver) {
                    const firstVariant = variants[0];
                    if (firstVariant) {
                      const weightGrams = window.getWeightGramsForVariant(firstVariant.variantId);
                      smartSaverMOQ = window.getSmartSaverMOQ(weightGrams);
                    }
                  }

                  const fixedOriginalUnitPrice = basePriceCents;

                  // Calculate customisation costs
                  const customisationCosts = window.calculateCustomisationCosts ? window.calculateCustomisationCosts() : { totalCost: 0 };
                  const customisationCostPerUnit = totalQty > 0 ? customisationCosts.totalCost / totalQty : 0;

                  const pricingResult = {
                    // original unit price (FIXED - never changes) in cents
                    originalUnitPrice: fixedOriginalUnitPrice,
                    // unit price after applying bulk tier (in cents) - changes based on quantity
                    unitPriceAfterBulk: bulkUnitPrice,
                    // final unit price after Smart Saver / delivery adjustments (in cents)
                    unitPriceFinal: unitPriceFinal,
                    totalFinal: totalFinal,
                    // presentation-friendly rates
                    bulkDiscountRate: bulkDiscountRate,
                    volumeDiscountRate: bulkDiscountRate,
                    smartSaverDiscountRate: smartSaverDiscountRate,
                    smartSaverMOQ: smartSaverMOQ,
                    multiplier: 1,
                    totalQty: totalQty,
                    // Customisation costs
                    customisationCostPerUnit: customisationCostPerUnit,
                    customisationCostTotal: customisationCosts.totalCost,
                    hasCustomisations: customisationCosts.totalCost > 0,
                    // Aliases for Liquid template compatibility
                    hasPrintingAddons: customisationCosts.totalCost > 0,
                    printingAddonsPerUnit: customisationCostPerUnit,
                    printingAddonsTotal: customisationCosts.totalCost
                  };
                  
                  console.log('[computeDisplayedPricing] Customisation costs:', {
                    totalCost: customisationCosts.totalCost,
                    perUnit: customisationCostPerUnit,
                    hasPrintingAddons: pricingResult.hasPrintingAddons,
                    printingAddonsTotal: pricingResult.printingAddonsTotal
                  });
                  
                  return pricingResult;
                };
                
                // Render custom price summary
                window.renderCustomPriceSummary = function() {
                  const pricing = window.computeDisplayedPricing();

                  // Find price summary container (do NOT auto-create this element; it should be rendered in Liquid)
                  const summaryContainer = document.getElementById('customPriceSummary');
                  if (!summaryContainer) {
                    return;
                  }

                  if (pricing.totalQty === 0) {
                    summaryContainer.style.display = 'none';
                    return;
                  }

                  summaryContainer.style.display = 'block';

                  const smartSaverRadio = document.getElementById('delivery-smart-saver');
                  const isSmartSaver = smartSaverRadio && smartSaverRadio.checked;

                  const formatPrice = (cents) => {
                    return (cents / 100).toFixed(2);
                  };

                  // Build ordered breakdown to match UI format:
                  // 1) Price (unit): Final unit price after all discounts
                  // 2) Bulk discount: Show bulk discount price if applicable
                  // 3) Smart Saver: Show discount percentage if selected
                  // 4) Customisations: Show each print location cost
                  // 5) Total: Final total including all costs
                  
                  const original = pricing.originalUnitPrice || 0;
                  const afterBulk = pricing.unitPriceAfterBulk || original;
                  const bulkRate = pricing.bulkDiscountRate || 0;
                  const smartRate = (isSmartSaver && pricing.smartSaverDiscountRate) ? pricing.smartSaverDiscountRate : 0;
                  const finalUnitPrice = pricing.unitPriceFinal || afterBulk;

                  // Bulk discount line - show if there's a bulk discount
                  let bulkLine = '';
                  if (bulkRate > 0) {
                    bulkLine = `<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;"><span style="font-size:0.9em;color:#666;">Bulk discount:</span><span style="font-size:1.0em;font-weight:600;color:#333;">$${formatPrice(afterBulk)}</span></div>`;
                  }

                  // Smart Saver line - show if selected
                  const smartLine = isSmartSaver ? `<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;"><span style="font-size:0.9em;color:#666;">Smart Saver:</span><span style="font-size:1.0em;font-weight:600;color:#333;">−${Math.round(smartRate * 100)}%</span></div>` : '';

                  // Get location details with costs
                  const locationDetails = window.getLocationDetailsWithCosts ? window.getLocationDetailsWithCosts() : [];
                  
                  // Build location cost lines (per location)
                  let locationLines = '';
                  locationDetails.forEach(location => {
                    if (location.cost > 0) {
                      locationLines += `<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;"><span style="font-size:0.9em;color:#666;">Print location ${location.locationNumber}: ${location.method}</span><span style="font-size:1.0em;font-weight:600;color:#333;">$${formatPrice(location.cost)}</span></div>`;
                    }
                  });
                  
                  // Calculate total customisation cost
                  const customisationCosts = window.calculateCustomisationCosts ? window.calculateCustomisationCosts() : { totalCost: 0 };
                  
                  // Calculate final total including customisation costs
                  const finalTotal = pricing.totalFinal + customisationCosts.totalCost;

                  summaryContainer.innerHTML = `
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                      <span style="font-size:0.9em;color:#666;">Price (unit):</span>
                      <span id="customOriginalUnitPrice" style="font-size:1.0em;font-weight:600;color:#333;">$${formatPrice(finalUnitPrice)}</span>
                    </div>
                    ${bulkLine}
                    ${smartLine}
                    ${locationLines}
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                      <span style="font-size:0.9em;color:#666;">Total:</span>
                      <span id="customTotalPrice" style="font-size:1.3em;font-weight:600;color:#000;">$${formatPrice(finalTotal)}</span>
                    </div>
                  `;
                };
                
                // Enforce Smart Saver MOQ
                window.enforceSmartSaverMOQ = function() {
                  const smartSaverRadio = document.getElementById('delivery-smart-saver');
                  const isSmartSaver = smartSaverRadio && smartSaverRadio.checked;
                  
                  if (!isSmartSaver) {
                    // Remove warning if Smart Saver not selected
                    const warning = document.getElementById('smartSaverMOQWarning');
                    if (warning) warning.remove();
                    
                    // Enable add to cart buttons
                    const gridAddBtn = document.getElementById('gridAddToCart');
                    if (gridAddBtn) gridAddBtn.disabled = false;
                    
                    return;
                  }
                  
                  const pricing = window.computeDisplayedPricing();
                  const totalQty = pricing.totalQty;
                  const smartSaverMOQ = pricing.smartSaverMOQ;
                  
                  if (smartSaverMOQ > 0 && totalQty < smartSaverMOQ) {
                    // Show warning
                    let warning = document.getElementById('smartSaverMOQWarning');
                    if (!warning) {
                      const summaryContainer = document.getElementById('customPriceSummary');
                      if (summaryContainer) {
                        warning = document.createElement('div');
                        warning.id = 'smartSaverMOQWarning';
                        warning.style.cssText = 'margin-top: 12px; padding: 12px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 6px; color: #856404; font-size: 0.9em;';
                        summaryContainer.appendChild(warning);
                      }
                    }
                    
                    if (warning) {
                      warning.textContent = `Smart Saver requires minimum ${smartSaverMOQ} units. Current: ${totalQty} units.`;
                    }
                    
                    // Disable add to cart buttons
                    const gridAddBtn = document.getElementById('gridAddToCart');
                    if (gridAddBtn) gridAddBtn.disabled = true;
                    
                    // Also disable box view add to cart if it exists
                    const boxAddBtn = document.querySelector('.custom-add-to-cart-wrapper button[type="submit"]');
                    if (boxAddBtn) boxAddBtn.disabled = true;
                  } else {
                    // Remove warning
                    const warning = document.getElementById('smartSaverMOQWarning');
                    if (warning) warning.remove();
                    
                    // Enable add to cart buttons
                    const gridAddBtn = document.getElementById('gridAddToCart');
                    if (gridAddBtn) gridAddBtn.disabled = false;
                    
                    const boxAddBtn = document.querySelector('.custom-add-to-cart-wrapper button[type="submit"]');
                    if (boxAddBtn) boxAddBtn.disabled = false;
                  }
                };
                
                // --- Delivery Card UI Helpers ---
                function getDeliveryCards() {
                  const smartSaverCard = document.querySelector('#delivery-smart-saver + .delivery-card');
                  // Standard can be either "delivery-standard" or "delivery-standard-express" depending on template
                  const standardInput = document.getElementById('delivery-standard-express') || document.getElementById('delivery-standard') || document.querySelector('.delivery-method-option input[value="Standard"]');
                  const standardCard = standardInput ? standardInput.parentElement?.querySelector('.delivery-card') || standardInput.nextElementSibling : document.querySelector('.delivery-method-option input[value="Standard"] + .delivery-card');
                  return { smartSaverCard, standardCard };
                }

                function ensureDeliveryCardUI() {
                  const { smartSaverCard, standardCard } = getDeliveryCards();

                  function getActionsRow(card) {
                    let row = card && card.querySelector('.delivery-card-actions');
                    if (!row && card) {
                      row = document.createElement('div');
                      row.className = 'delivery-card-actions';
                      const tooltip = card.querySelector('.delivery-tooltip');
                      const top = card.querySelector('.delivery-card-top');
                      if (top && tooltip) {
                        top.appendChild(row);
                        row.appendChild(tooltip);
                      } else if (tooltip && tooltip.parentElement) {
                        tooltip.parentElement.insertBefore(row, tooltip);
                        row.appendChild(tooltip);
                      } else {
                        card.appendChild(row);
                      }
                    }
                    return row;
                  }

                  // --- Smart Saver: SAVE pill + MOQ + info (compact row) ---
                  if (smartSaverCard) {
                    const summary = smartSaverCard.querySelector('.delivery-summary');
                    if (summary) {
                      summary.remove();
                    }

                    const actions = getActionsRow(smartSaverCard);
                    const tooltip = actions ? actions.querySelector('.delivery-tooltip') : null;

                    let moqEl = smartSaverCard.querySelector('.smart-saver-moq-badge');
                    if (!moqEl && actions) {
                      moqEl = document.createElement('span');
                      moqEl.className = 'delivery-moq-inline smart-saver-moq-badge';
                      if (tooltip) {
                        actions.insertBefore(moqEl, tooltip);
                      } else {
                        actions.appendChild(moqEl);
                      }
                    }

                    let savePill = actions ? actions.querySelector('.save-pill-badge') : null;
                    if (!savePill && actions) {
                      savePill = document.createElement('span');
                      savePill.className = 'save-pill-badge best-value-badge';
                      savePill.textContent = 'SAVE 15%';
                      if (moqEl && moqEl.parentElement === actions) {
                        actions.insertBefore(savePill, moqEl);
                      } else if (tooltip) {
                        actions.insertBefore(savePill, tooltip);
                      } else {
                        actions.insertBefore(savePill, actions.firstChild);
                      }
                    }

                    // Order: save → MOQ → tooltip
                    if (actions && tooltip && moqEl) {
                      actions.insertBefore(moqEl, tooltip);
                    }
                    if (actions && moqEl && savePill) {
                      actions.insertBefore(savePill, moqEl);
                    }

                    // Remove legacy full-width MOQ / duplicate badges
                    smartSaverCard.querySelectorAll('.delivery-badge.smart-saver-badge').forEach(el => el.remove());
                    smartSaverCard.querySelectorAll('.smart-saver-moq, .moq-badge').forEach(el => {
                      if (!el.classList.contains('smart-saver-moq-badge')) el.remove();
                    });

                    const wrapper = document.querySelector('.volume-discount-slider-wrapper');
                    let smartSaverMOQ = wrapper && wrapper.dataset && parseInt(wrapper.dataset.moq, 10) ? parseInt(wrapper.dataset.moq, 10) : 0;
                    if (!smartSaverMOQ && typeof window.getSmartSaverMOQ === 'function') {
                      const variants = window.getSelectedVariantsWithQty ? window.getSelectedVariantsWithQty() : [];
                      if (variants.length > 0 && typeof window.getWeightGramsForVariant === 'function') {
                        const weightGrams = window.getWeightGramsForVariant(variants[0].variantId);
                        if (weightGrams > 0) {
                          smartSaverMOQ = window.getSmartSaverMOQ(weightGrams);
                        }
                      }
                    }

                    if (moqEl) {
                      if (smartSaverMOQ > 0) {
                        moqEl.textContent = `MOQ ${smartSaverMOQ} units`;
                        moqEl.style.display = '';
                      } else {
                        moqEl.textContent = '';
                        moqEl.style.display = 'none';
                      }
                    }

                    const oldSaveBadge = smartSaverCard.querySelector('.delivery-save-badge');
                    if (oldSaveBadge) {
                      oldSaveBadge.remove();
                    }
                  }

                  // --- Standard Express: MOQ + info ---
                  if (standardCard) {
                    const inlineBadges = standardCard.querySelectorAll('.delivery-info .delivery-badge');
                    inlineBadges.forEach(b => b.remove());

                    const extraStd = standardCard.querySelectorAll('.express-moq-badge');
                    if (extraStd.length > 1) {
                      extraStd.forEach((el, idx) => { if (idx > 0) el.remove(); });
                    }

                    const actions = getActionsRow(standardCard);
                    const tooltip = actions ? actions.querySelector('.delivery-tooltip') : null;

                    let stdBadge = standardCard.querySelector('.express-moq-badge');
                    if (!stdBadge && actions) {
                      stdBadge = document.createElement('span');
                      stdBadge.className = 'delivery-moq-inline express-moq-badge';
                      if (tooltip) {
                        actions.insertBefore(stdBadge, tooltip);
                      } else {
                        actions.appendChild(stdBadge);
                      }
                    } else if (stdBadge && actions && tooltip && stdBadge.parentElement !== actions) {
                      actions.insertBefore(stdBadge, tooltip);
                    }

                    const allPrintingMethods = document.querySelectorAll('input[name*="_printing_method"]:checked');
                    let hasEmbroidery = false;
                    allPrintingMethods.forEach(input => {
                      if (input && (input.value === 'Embroidery' || String(input.value).toLowerCase().includes('embroidery'))) {
                        hasEmbroidery = true;
                      }
                    });
                    const requiredMOQ = 1;
                    const displayMOQ = hasEmbroidery ? cmpEmbroideryBulkMin() : requiredMOQ;
                    if (stdBadge) {
                      stdBadge.textContent = `MOQ ${displayMOQ} units`;
                      stdBadge.style.display = '';
                    }
                  }

                  if (smartSaverCard && standardCard) {
                    smartSaverCard.style.minHeight = '';
                    standardCard.style.minHeight = '';

                    requestAnimationFrame(() => {
                      const h = Math.max(smartSaverCard.offsetHeight || 0, standardCard.offsetHeight || 0);
                      if (h > 0) {
                        smartSaverCard.style.minHeight = h + 'px';
                        standardCard.style.minHeight = h + 'px';
                      }
                    });
                  }
                }

                 function liftBestValueMarker() {
                   const marker = document.querySelector('.best-value-marker, .best-value-bubble, .best-value');
                   if (!marker) return;
 
                   // Marker is now positioned above slider via CSS (bottom: 100%)
                   // Just ensure it's visible and properly positioned
                   if (marker.style.position === 'relative') {
                     marker.style.position = '';
                     marker.style.top = '';
                   }
                 }

                // Recalculate pricing (main entry point)
                window.recalculatePricing = function() {
                  // Ensure UI structure exists first (badges/summary/height)
                  ensureDeliveryCardUI();
                  liftBestValueMarker();

                  window.renderCustomPriceSummary();
                  window.enforceSmartSaverMOQ();

                  // Update Smart Saver MOQ badge dynamically
                  const smartSaverRadio = document.getElementById('delivery-smart-saver');
                  if (smartSaverRadio) {
                    const variants = window.getSelectedVariantsWithQty();
                    if (variants.length > 0) {
                      const weightGrams = window.getWeightGramsForVariant(variants[0].variantId);
                      const smartSaverMOQ = window.getSmartSaverMOQ(weightGrams);

                      // Update Smart Saver MOQ badge with "Minimum order: X units" format
                      const smartSaverBadge = document.querySelector('#delivery-smart-saver + .delivery-card .smart-saver-moq-badge');
                      if (smartSaverBadge && smartSaverMOQ > 0) {
                        smartSaverBadge.textContent = `MOQ ${smartSaverMOQ} units`;
                      }

                      // Re-apply equal heights after text updates
                      ensureDeliveryCardUI();
                    } else {
                      // Still keep the cards equal if nothing selected yet
                      ensureDeliveryCardUI();
                    }
                  }
                };
                
                // Initialize pricing data on load
                initializePricingData();
                
                // Listen for printing method MOQ changes to update Smart Saver MOQ display
                document.addEventListener('printingMethodMOQChanged', function(event) {
                  // Smart Saver MOQ is independent of printing method MOQ
                  // But we should still recalculate pricing
                  if (window.recalculatePricing) {
                    window.recalculatePricing();
                  }
                });
                
                // Initialize pricing on page load (after DOM is ready)
                setTimeout(() => {
                  if (window.recalculatePricing) {
                    window.recalculatePricing();
                  }
                }, 1000);

                // Safety: re-run MOQ enforcement after short delays to catch late DOM updates
                // This prevents visual desync where another script or render resets slider attributes after initial enforcement.
                const safeEnforce = () => {
                  try {
                    if (typeof window.updateMOQBasedOnPrintingMethods === 'function') {
                      window.updateMOQBasedOnPrintingMethods();
                    } else if (typeof window.enforcePrintingMethodMOQ === 'function') {
                      window.enforcePrintingMethodMOQ();
                    }
                  } catch (e) {}
                };
                setTimeout(safeEnforce, 50);
                setTimeout(safeEnforce, 300);
                setTimeout(safeEnforce, 1000);

                // Ensure delivery card heights are correct after images/fonts load
                setTimeout(() => {
                  try {
                    ensureDeliveryCardUI();
                    liftBestValueMarker();
                  } catch (e) {}
                }, 2000);
                
                // Helper function to determine size badge based on location value
                function getLocationSize(locationValue) {
                  if (window.__CMP_BUILDER_CONFIG && window.__CMP_BUILDER_CONFIG.profile === 'hats_beanies') {
                    const hatLargeLocations = ['Full Crown Front', 'Full Back Panel', 'Bill Full Width'];
                    return hatLargeLocations.includes(locationValue) ? 'Large' : 'Small';
                  }
                  // Shared rulebook: band from the location's default print size (assets/ea-print-rules.js)
                  if (window.EA_PRINT_RULES) return window.EA_PRINT_RULES.locationSize(locationValue);
                  const largeLocations = [
                    'Full Front', 'Lower Front', 'Vertical Left', 'Vertical Right',
                    'Top Back', 'Center Back', 'Lower Back', 'Vertical Back L', 'Vertical Back R'
                  ];
                  return largeLocations.includes(locationValue) ? 'Large' : 'Small';
                }
                
                // Print lines for the cart, shared by every add-to-cart path (grid, box view).
                // Returns { items, artworkItems }: lines without files go in the JSON request,
                // lines with files are posted one by one by eaUploadArtworkLines.
                window.eaBuildPrintLines = function(baseVariantIds, totalQty) {
                  const items = [];
                  const artworkItems = [];
                  if (!totalQty) return { items, artworkItems };
                  document.querySelectorAll('.print-location-card').forEach((card, index) => {
                    const methodInput = card.querySelector('input[name*="_printing_method"]:checked');
                    const spotInput = card.querySelector('input[name*="_spot"]:checked');
                    if (!methodInput || !spotInput) return;
                    const method = methodInput.value;
                    if (method !== 'Digital Print' && method !== 'Embroidery') return;
                    const placement = spotInput.value;
                    const size = spotInput.dataset.customisationSize || spotInput.dataset.locationSize || getLocationSize(placement);
                    const variantId = spotInput.dataset.customisationVariantId || CUSTOMISATION_VARIANTS[method]?.[size];
                    if (!variantId) return;
                    // Cards from the design tool carry their files and position on card._eaPrint
                    const designed = card._eaPrint || null;
                    const artworkInput = card.querySelector('input[type="file"]');
                    const artwork = designed ? designed.file : (artworkInput && artworkInput.files && artworkInput.files[0]) || null;
                    const properties = {
                      '_customisation_method': method,
                      '_customisation_size': size,
                      '_linked_to_base_product': 'true',
                      '_print_location': `Location ${index + 1}: ${placement}`,
                      '_base_variants': baseVariantIds.join(','),
                      '_location_details': `${placement} (${method}, ${size})`
                    };
                    if (designed && designed.props) Object.assign(properties, designed.props);
                    // Each location applies to every unit (10 hoodies = 10 customisation units)
                    const line = { id: variantId, quantity: totalQty, properties };
                    if (artwork) {
                      artworkItems.push({
                        ...line,
                        artwork,
                        // the customer's untouched file, when the tool edited it (e.g. background removed)
                        original: designed && designed.original && designed.original !== artwork ? designed.original : null,
                        mockup: designed ? designed.mockup : null
                      });
                    } else items.push(line);
                  });
                  return { items, artworkItems };
                };

                // Posts print lines with their files (Artwork, Original upload, Mockup) as multipart
                // form data. Retries once; if the files still won't upload, the print line is added
                // without them and flagged, so a print is never silently dropped from the order.
                window.eaUploadArtworkLines = async function(artworkItems) {
                  const failed = [];
                  const post = (item, withFiles) => {
                    const formData = new FormData();
                    formData.append('id', item.id);
                    formData.append('quantity', item.quantity);
                    Object.entries(item.properties).forEach(([key, value]) => formData.append(`properties[${key}]`, value));
                    if (withFiles) {
                      formData.append('properties[Artwork]', item.artwork, item.artwork.name);
                      if (item.original) formData.append('properties[Original upload]', item.original, item.original.name);
                      if (item.mockup) formData.append('properties[Mockup]', item.mockup, item.mockup.name);
                    } else {
                      formData.append('properties[Artwork status]', `Upload failed (${item.artwork.name}). We will contact you for the file.`);
                    }
                    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
                      .then((r) => r.ok)
                      .catch(() => false);
                  };
                  for (const item of artworkItems) {
                    if (await post(item, true)) continue;
                    if (await post(item, true)) continue;
                    console.warn('[AddToCart] Artwork upload failed for', item.properties._print_location);
                    failed.push(item.artwork.name);
                    await post(item, false);
                  }
                  if (failed.length) {
                    alert(`Your order was added to the cart, but we couldn't upload ${failed.join(', ')}. We'll contact you for the file, or you can attach it again from the cart.`);
                  }
                  return failed;
                };

                // Get customisation counts per method+size from all location cards
                // Returns: { 'Digital Print': { 'Small': count, 'Large': count }, 'Embroidery': { 'Small': count, 'Large': count } }
                window.getCustomisationCounts = function() {
                  const counts = {
                    'Digital Print': { 'Small': 0, 'Medium': 0, 'Large': 0, 'XL': 0 },
                    'Embroidery': { 'Small': 0, 'Medium': 0, 'Large': 0, 'XL': 0 }
                  };
                  
                  // Get all location cards
                  const locationCards = document.querySelectorAll('.print-location-card');
                  
                  locationCards.forEach(card => {
                    // Get printing method
                    const methodInput = card.querySelector('input[name*="_printing_method"]:checked');
                    if (!methodInput) return;
                    
                    const method = methodInput.value;
                    if (method !== 'Digital Print' && method !== 'Embroidery') return;
                    
                    // Get location spot
                    const spotInput = card.querySelector('input[name*="_spot"]:checked');
                    if (!spotInput) return;
                    
                    const locationValue = spotInput.value;
                    // Use data attribute if available, otherwise calculate
                    const size = spotInput.dataset.customisationSize || spotInput.dataset.locationSize || getLocationSize(locationValue);
                    
                    // Count this location (each location card = 1 customisation)
                    if (counts[method] && counts[method][size] !== undefined) {
                      counts[method][size]++;
                    }
                  });
                  
                  return counts;
                };
                
                // Cache for customisation variant prices
                window._customisationVariantPrices = window._customisationVariantPrices || {};
                
                // Get customisation variant price in cents
                // Returns price in cents, or 0 if variant not found
                window.getCustomisationVariantPrice = function(method, size) {
                  const variantId = CUSTOMISATION_VARIANTS[method]?.[size];
                  if (!variantId) {
                    console.warn(`[getCustomisationVariantPrice] No variant ID for ${method} ${size}`);
                    return 0;
                  }
                  
                  // Check cache first (fastest)
                  if (window._customisationVariantPrices && window._customisationVariantPrices[variantId]) {
                    return window._customisationVariantPrices[variantId];
                  }
                  
                  // Check in pricing data (if customization variants are included)
                  if (!window._pricingProductData) {
                    initializePricingData();
                  }
                  
                  const variant = window._pricingProductData?.find(pv => String(pv.id) === String(variantId));
                  if (variant && variant.price) {
                    if (!window._customisationVariantPrices) {
                      window._customisationVariantPrices = {};
                    }
                    window._customisationVariantPrices[variantId] = variant.price;
                    return variant.price;
                  }
                  
                  // If not found, trigger async fetch (but return 0 for now)
                  // The fetch will update the cache and trigger recalculation
                  if (!window._customisationVariantPriceFetching) {
                    window._customisationVariantPriceFetching = {};
                  }
                  if (!window._customisationVariantPriceFetching[variantId]) {
                    window._customisationVariantPriceFetching[variantId] = true;
                    window.fetchCustomisationVariantPrice(variantId).then(price => {
                      if (price > 0 && window.recalculatePricing) {
                        window.recalculatePricing();
                      }
                      window._customisationVariantPriceFetching[variantId] = false;
                    }).catch(() => {
                      window._customisationVariantPriceFetching[variantId] = false;
                    });
                  }
                  
                  // Fallback to hardcoded prices if available (temporary until fetch completes)
                  if (CUSTOMISATION_VARIANT_PRICES && CUSTOMISATION_VARIANT_PRICES[variantId]) {
                    const price = CUSTOMISATION_VARIANT_PRICES[variantId];
                    if (!window._customisationVariantPrices) {
                      window._customisationVariantPrices = {};
                    }
                    window._customisationVariantPrices[variantId] = price;
                    console.log(`[getCustomisationVariantPrice] Using fallback hardcoded price for ${method} ${size} (${variantId}): ${price} cents`);
                    return price;
                  }
                  
                  console.warn(`[getCustomisationVariantPrice] No price found for variant ${variantId} (${method} ${size}), fetching...`);
                  return 0;
                };
                
                // Fetch customisation variant price asynchronously from Shopify variant API
                // This will fetch and cache the price
                window.fetchCustomisationVariantPrice = async function(variantId) {
                  if (!variantId) return 0;
                  
                  // Check cache first
                  if (window._customisationVariantPrices && window._customisationVariantPrices[variantId]) {
                    return window._customisationVariantPrices[variantId];
                  }
                  
                  // Check in pricing data
                  if (!window._pricingProductData) {
                    initializePricingData();
                  }
                  
                  const variant = window._pricingProductData?.find(pv => String(pv.id) === String(variantId));
                  if (variant && variant.price) {
                    if (!window._customisationVariantPrices) {
                      window._customisationVariantPrices = {};
                    }
                    window._customisationVariantPrices[variantId] = variant.price;
                    return variant.price;
                  }
                  
                  // Fetch from Shopify variant API endpoint
                  try {
                    const response = await fetch(`/variants/${variantId}.js`);
                    if (!response.ok) {
                      throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const variantData = await response.json();
                    
                    if (variantData && variantData.price) {
                      const price = variantData.price;
                      if (!window._customisationVariantPrices) {
                        window._customisationVariantPrices = {};
                      }
                      window._customisationVariantPrices[variantId] = price;
                      console.log(`[fetchCustomisationVariantPrice] Fetched price for variant ${variantId}: ${price} cents`);
                      return price;
                    } else {
                      console.warn(`[fetchCustomisationVariantPrice] Variant ${variantId} data missing price field`);
                    }
                  } catch (error) {
                    console.error(`[fetchCustomisationVariantPrice] Error fetching variant ${variantId} price:`, error);
                    // Fallback to hardcoded price if available
                    if (CUSTOMISATION_VARIANT_PRICES && CUSTOMISATION_VARIANT_PRICES[variantId]) {
                      const fallbackPrice = CUSTOMISATION_VARIANT_PRICES[variantId];
                      if (!window._customisationVariantPrices) {
                        window._customisationVariantPrices = {};
                      }
                      window._customisationVariantPrices[variantId] = fallbackPrice;
                      console.log(`[fetchCustomisationVariantPrice] Using fallback hardcoded price for variant ${variantId}: ${fallbackPrice} cents`);
                      return fallbackPrice;
                    }
                  }
                  
                  return 0;
                };
                
                // Calculate total customisation cost
                // Returns: { digitalPrintCost: cents, embroideryCost: cents, totalCost: cents, breakdown: array }
                window.calculateCustomisationCosts = function() {
                  const counts = window.getCustomisationCounts();
                  const totalQty = window.getTotalQty ? window.getTotalQty() : 0;
                  
                  console.log('[calculateCustomisationCosts] Counts:', counts, 'TotalQty:', totalQty);
                  
                  let digitalPrintCost = 0;
                  let embroideryCost = 0;
                  const breakdown = [];
                  
                  // Prints get the garments' bulk % (window.eaAddonBulkRate, custom-main-product.liquid)
                  const addonRate = typeof window.eaAddonBulkRate === 'function' ? window.eaAddonBulkRate(totalQty) : 0;
                  // Cost per method = sum over every size band (Small / Medium / Large / XL)
                  const SIZE_BANDS = ['Small', 'Medium', 'Large', 'XL'];
                  const costFor = (method) => {
                    let cost = 0;
                    const qtyBySize = {};
                    SIZE_BANDS.forEach((size) => {
                      const qty = (counts[method] && counts[method][size]) || 0;
                      if (!qty) return;
                      qtyBySize[size] = qty;
                      cost += Math.round(window.getCustomisationVariantPrice(method, size) * (1 - addonRate)) * qty * totalQty;
                    });
                    if (cost > 0) {
                      breakdown.push({ method, smallQty: qtyBySize.Small || 0, largeQty: qtyBySize.Large || 0, qtyBySize, cost });
                    }
                    return cost;
                  };
                  digitalPrintCost = costFor('Digital Print');
                  embroideryCost = costFor('Embroidery');

                  const result = {
                    digitalPrintCost: digitalPrintCost,
                    embroideryCost: embroideryCost,
                    totalCost: digitalPrintCost + embroideryCost,
                    breakdown: breakdown
                  };
                  
                  console.log('[calculateCustomisationCosts] Result:', result);
                  return result;
                };
                
                // Get location details with costs per location
                // Returns: array of { locationNumber, method, size, placement, cost }
                window.getLocationDetailsWithCosts = function() {
                  const locationDetails = [];
                  const locationCards = document.querySelectorAll('.print-location-card');
                  const totalQty = window.getTotalQty ? window.getTotalQty() : 0;
                  
                  locationCards.forEach((card, index) => {
                    const methodInput = card.querySelector('input[name*="_printing_method"]:checked');
                    const spotInput = card.querySelector('input[name*="_spot"]:checked');
                    
                    if (methodInput && spotInput) {
                      const method = methodInput.value;
                      const locationValue = spotInput.value;
                      
                      // Get size and variant ID from data attributes if available, otherwise calculate
                      const size = spotInput.dataset.customisationSize || spotInput.dataset.locationSize || getLocationSize(locationValue);
                      const variantId = spotInput.dataset.customisationVariantId || CUSTOMISATION_VARIANTS[method]?.[size];
                      
                      if (method === 'Digital Print' || method === 'Embroidery') {
                        // Get unit price from variant ID
                        let unitPrice = 0;
                        
                        if (variantId) {
                          // Ensure pricing data is initialized
                          if (!window._pricingProductData) {
                            initializePricingData();
                          }
                          
                          // Check cache first
                          if (window._customisationVariantPrices && window._customisationVariantPrices[variantId]) {
                            unitPrice = window._customisationVariantPrices[variantId];
                          } else if (window._pricingProductData) {
                            // Check in pricing data
                            const variant = window._pricingProductData.find(pv => String(pv.id) === String(variantId));
                            if (variant && variant.price) {
                              unitPrice = variant.price;
                              // Cache it
                              if (!window._customisationVariantPrices) {
                                window._customisationVariantPrices = {};
                              }
                              window._customisationVariantPrices[variantId] = variant.price;
                            } else {
                              // Variant not in product data - try to fetch
                              // For now, use helper function which will attempt to fetch
                              unitPrice = window.getCustomisationVariantPrice(method, size);
                              
                              // If still 0, try async fetch
                              if (unitPrice === 0) {
                                window.fetchCustomisationVariantPrice(variantId).then(price => {
                                  if (price > 0 && window.recalculatePricing) {
                                    window.recalculatePricing();
                                  }
                                }).catch(() => {
                                  // Silently fail - price will show as 0 until loaded
                                });
                              }
                            }
                          } else {
                            // Fallback to method+size lookup
                            unitPrice = window.getCustomisationVariantPrice(method, size);
                          }
                        } else {
                          // Fallback to method+size lookup
                          unitPrice = window.getCustomisationVariantPrice(method, size);
                        }
                        
                        const addonRate = typeof window.eaAddonBulkRate === 'function' ? window.eaAddonBulkRate(totalQty) : 0;
                        const totalCost = Math.round(unitPrice * (1 - addonRate)) * totalQty;
                        
                        locationDetails.push({
                          locationNumber: index + 1,
                          method: method,
                          size: size,
                          placement: locationValue,
                          cost: totalCost,
                          variantId: variantId
                        });
                      }
                    }
                  });
                  
                  return locationDetails;
                };
                
                window.updateSpotOptions = function(locationId, area) {
                  const spotsContainer = document.getElementById(`${locationId}-spots`);
                  if (!spotsContainer) return;
                  // "More placement options" must not live inside `.location-spots-grid`: it is a fourth grid
                  // child alongside the default tiles and breaks `repeat(auto-fit, minmax(0, 1fr))` (tiny tiles).
                  const existingMore = document.getElementById(`${locationId}-more-options`);
                  if (existingMore) existingMore.remove();
                  spotsContainer.innerHTML = '';
                  
                  if (!area || !printLocations[area]) return;
                  
                  const areaData = printLocations[area];
                  let spotIndex = 0;
                  
                  // Render default options
                  if (areaData.default && areaData.default.length > 0) {
                    areaData.default.forEach((spot) => {
                      const sizeBadge = getLocationSize(spot.value);
                      const size = sizeBadge; // 'Small' or 'Large'
                      const spotDiv = document.createElement('div');
                      spotDiv.className = 'spot-option';
                      const spotInput = document.createElement('input');
                      spotInput.type = 'radio';
                      spotInput.id = `${locationId}-spot-${spotIndex}`;
                      spotInput.name = `properties[${locationId}_spot]`;
                      spotInput.value = spot.value;
                      spotInput.setAttribute('form', productFormId);
                      spotInput.required = true;
                      // Store size as data attribute for easy lookup
                      spotInput.dataset.locationSize = size;
                      spotDiv.appendChild(spotInput);
                      const label = document.createElement('label');
                      label.htmlFor = `${locationId}-spot-${spotIndex}`;
                      label.innerHTML = `
                        <span class="spot-size-badge">${sizeBadge}</span>
                        <img src="${spot.img}" alt="${spot.label}">
                        <span class="spot-label-text">${spot.label}</span>
                      `;
                      spotDiv.appendChild(label);
                      spotsContainer.appendChild(spotDiv);
                      spotIndex++;
                    });
                  }
                  
                  // Update variant IDs on spot inputs after rendering
                  const card = document.getElementById(locationId);
                  if (card) {
                    const methodInput = card.querySelector('input[name*="_printing_method"]:checked');
                    if (methodInput) {
                      const method = methodInput.value;
                      if (method === 'Digital Print' || method === 'Embroidery') {
                        const spotInputs = spotsContainer.querySelectorAll('input[name*="_spot"]');
                        spotInputs.forEach(spotInput => {
                          const size = spotInput.dataset.locationSize || getLocationSize(spotInput.value);
                          const variantId = CUSTOMISATION_VARIANTS[method]?.[size];
                          if (variantId) {
                            spotInput.dataset.customisationVariantId = variantId;
                            spotInput.dataset.customisationMethod = method;
                            spotInput.dataset.customisationSize = size;
                          }
                        });
                      }
                    }
                  }
                  
                  // Add "More placement options" toggle if there are advanced options
                  if (areaData.advanced && areaData.advanced.length > 0) {
                    const moreOptionsContainer = document.createElement('div');
                    moreOptionsContainer.className = 'more-options-container';
                    moreOptionsContainer.id = `${locationId}-more-options`;
                    
                    const toggleButton = document.createElement('button');
                    toggleButton.type = 'button';
                    toggleButton.className = 'more-options-toggle';
                    toggleButton.innerHTML = `
                      <span>More placement options</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>
                    `;
                    
                    const advancedOptionsGrid = document.createElement('div');
                    advancedOptionsGrid.className = 'location-spots-grid advanced-options-grid';
                    
                    areaData.advanced.forEach((spot) => {
                      const sizeBadge = getLocationSize(spot.value);
                      const size = sizeBadge; // 'Small' or 'Large'
                      const spotDiv = document.createElement('div');
                      spotDiv.className = 'spot-option';
                      const spotInput = document.createElement('input');
                      spotInput.type = 'radio';
                      spotInput.id = `${locationId}-spot-${spotIndex}`;
                      spotInput.name = `properties[${locationId}_spot]`;
                      spotInput.value = spot.value;
                      spotInput.setAttribute('form', productFormId);
                      spotInput.required = true;
                      // Store size as data attribute for easy lookup
                      spotInput.dataset.locationSize = size;
                      // Also set variant ID if method is already selected
                      const card = document.getElementById(locationId);
                      if (card) {
                        const methodInput = card.querySelector('input[name*="_printing_method"]:checked');
                        if (methodInput) {
                          const method = methodInput.value;
                          if (method === 'Digital Print' || method === 'Embroidery') {
                            const variantId = CUSTOMISATION_VARIANTS[method]?.[size];
                            if (variantId) {
                              spotInput.dataset.customisationVariantId = variantId;
                              spotInput.dataset.customisationMethod = method;
                              spotInput.dataset.customisationSize = size;
                            }
                          }
                        }
                      }
                      spotDiv.appendChild(spotInput);
                      const label = document.createElement('label');
                      label.htmlFor = `${locationId}-spot-${spotIndex}`;
                      label.innerHTML = `
                        <span class="spot-size-badge">${sizeBadge}</span>
                        <img src="${spot.img}" alt="${spot.label}">
                        <span class="spot-label-text">${spot.label}</span>
                      `;
                      spotDiv.appendChild(label);
                      advancedOptionsGrid.appendChild(spotDiv);
                      spotIndex++;
                    });
                    
                    toggleButton.addEventListener('click', function(e) {
                      e.preventDefault();
                      e.stopPropagation();
                      
                      const isExpanded = advancedOptionsGrid.classList.contains('expanded');
                      
                      if (isExpanded) {
                        advancedOptionsGrid.classList.remove('expanded');
                        toggleButton.classList.remove('expanded');
                      } else {
                        advancedOptionsGrid.classList.add('expanded');
                        toggleButton.classList.add('expanded');
                      }
                    });
                    
                    moreOptionsContainer.appendChild(toggleButton);
                    moreOptionsContainer.appendChild(advancedOptionsGrid);
                    spotsContainer.insertAdjacentElement('afterend', moreOptionsContainer);
                  }
                  
                  // After rendering spot options, attempt to re-render thumbnails so any newly-available
                  // placement aspect ratio is applied immediately.
                  try { reRenderPlacementThumbnails(); } catch (e) { /* ignore errors */ }
                };
                
                window.handleFileUpload = function(locationId, input) {
                  const uploadSection = document.getElementById(`${locationId}-upload`);
                  const preview = document.getElementById(`${locationId}-preview`);
                  const file = input.files[0];
                  
                  if (!file) {
                    uploadSection.classList.remove('has-file');
                    preview.classList.remove('show');
                    return;
                  }
                  
                  uploadSection.classList.add('has-file');
                  
                  const fileSize = (file.size / 1024 / 1024).toFixed(2);
                  
                  if (file.type.startsWith('image/')) {
                    const reader = new FileReader();
                    reader.onload = function(e) {
                      preview.innerHTML = `
                        <img src="${e.target.result}" alt="Preview">
                        <div class="file-info">
                          <div class="file-name">${file.name}</div>
                          <div class="file-size">${fileSize} MB</div>
                        </div>
                      `;
                      preview.classList.add('show');
                    };
                    reader.readAsDataURL(file);
                  } else {
                    preview.innerHTML = `
                      <div class="file-info">
                        <div class="file-name">${file.name}</div>
                        <div class="file-size">${fileSize} MB</div>
                      </div>
                    `;
                    preview.classList.add('show');
                  }
                };
                
                window.removeLocation = function(locationId) {
                  const card = document.getElementById(locationId);
                  if (card) {
                    card.style.opacity = '0';
                    card.style.transform = 'scale(0.95)';
                    setTimeout(() => {
                      card.remove();
                      // Renumber remaining locations
                      const cards = container.querySelectorAll('.print-location-card');
                      const locLabel =
                        window.__CMP_BUILDER_CONFIG && window.__CMP_BUILDER_CONFIG.profile === 'hats_beanies'
                          ? 'Decoration location'
                          : 'Print location';
                      cards.forEach((c, index) => {
                        const num = c.querySelector('.location-number');
                        if (num) num.textContent = `${locLabel} #${index + 1}`;
                      });
                      // keep locationCount increasing so new card ids never clash with existing ones
                      
                      // Update MOQ and pricing after removal
                      updateMOQBasedOnPrintingMethods();
                      if (window.recalculatePricing) {
                        window.recalculatePricing();
                      }
                    }, 300);
                  }
                };
                
                // Add location when button is clicked
                addBtn.addEventListener('click', createLocationCard);
                
                // ============================================
                // DELIVERY TIMELINE SYSTEM
                // ============================================
                // This system manages TWO delivery timelines:
                // 1. Plain/Blanks Timeline (fast shipping, no production)
                // 2. Custom Timeline (production + shipping, or Smart Saver sea freight)
                // 
                // Both timelines exist in DOM but only one is visible based on view mode.
                // Timeline visibility is controlled by parent view containers.
                // ============================================
                
                // Delivery Expectations Date Calculator
                function addBusinessDays(startDate, days) {
                  const result = new Date(startDate);
                  let addedDays = 0;
                  while (addedDays < days) {
                    result.setDate(result.getDate() + 1);
                    // Skip weekends (Saturday = 6, Sunday = 0)
                    if (result.getDay() !== 0 && result.getDay() !== 6) {
                      addedDays++;
                    }
                  }
                  return result;
                }
                
                function addBusinessDaysFromDate(startDate, minDays, maxDays) {
                  return {
                    min: addBusinessDays(startDate, minDays),
                    max: addBusinessDays(startDate, maxDays)
                  };
                }
                
                function formatDate(date) {
                  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                  const day = date.getDate();
                  const month = months[date.getMonth()];
                  const suffix = day === 1 || day === 21 || day === 31 ? 'st' :
                                 day === 2 || day === 22 ? 'nd' :
                                 day === 3 || day === 23 ? 'rd' : 'th';
                  return `${month} ${day}${suffix}`;
                }
                
                // Update Plain/Blanks Delivery Timeline
                function updatePlainDeliveryExpectations() {
                  const orderConfirmedEl = document.getElementById('orderConfirmedDate');
                  const shippedEl = document.getElementById('shippedDate');
                  const deliveredEl = document.getElementById('deliveredDate');
                  const estimatedRangeEl = document.getElementById('estimatedDeliveryRange');
                  const footerEl = document.getElementById('deliveryTimelineFooter');
                  
                  if (!orderConfirmedEl || !shippedEl || !deliveredEl || !estimatedRangeEl) return;
                  
                  const today = new Date();
                  const orderConfirmedDate = today;
                  
                  // Dispatch: 1-2 business days
                  const dispatchDates = addBusinessDaysFromDate(orderConfirmedDate, 1, 2);
                  
                  // Delivery: 1-4 business days from dispatch
                  const deliveredDates = {
                    min: addBusinessDays(dispatchDates.min, 1),
                    max: addBusinessDays(dispatchDates.max, 4)
                  };
                  
                  orderConfirmedEl.textContent = formatDate(orderConfirmedDate);
                  
                  if (dispatchDates.min.getTime() === dispatchDates.max.getTime()) {
                    shippedEl.textContent = formatDate(dispatchDates.min);
                  } else {
                    shippedEl.textContent = `${formatDate(dispatchDates.min)} to ${formatDate(dispatchDates.max)}`;
                  }
                  
                  if (deliveredDates.min.getTime() === deliveredDates.max.getTime()) {
                    deliveredEl.textContent = formatDate(deliveredDates.min);
                  } else {
                    deliveredEl.textContent = `${formatDate(deliveredDates.min)} to ${formatDate(deliveredDates.max)}`;
                  }
                  
                  // Update estimated delivery range
                  const estimatedRange = `${formatDate(deliveredDates.min)} to ${formatDate(deliveredDates.max)}`;
                  estimatedRangeEl.textContent = `Standard (Stock) ${estimatedRange}`;
                  
                  // Update footer for blank view
                  if (footerEl) {
                    footerEl.innerHTML = '<div style="margin-bottom: 4px; text-align: center; font-style: italic; color: #999;">Stock items ship fast. No printing or production time.</div>';
                  }
                }
                
                // Extra days to add when showing custom timeline relative to blanks
                const CUSTOM_EXTRA_DAYS = 3;

                // Update Custom Delivery Timeline
                function updateCustomDeliveryExpectations(mode, offsetDays = 0) {
                  const orderConfirmedEl = document.getElementById('orderConfirmedDate');
                  const shippedEl = document.getElementById('shippedDate');
                  const deliveredEl = document.getElementById('deliveredDate');
                  const estimatedRangeEl = document.getElementById('estimatedDeliveryRange');
                  const footerEl = document.getElementById('deliveryTimelineFooter');
                  
                  if (!orderConfirmedEl || !shippedEl || !deliveredEl || !estimatedRangeEl) return;
                  
                  const today = new Date();
                  const orderConfirmedDate = today;
                  
                  if (mode === 'smart_saver') {
                    // Smart Saver: 80% ≤ 22 business days, 95% ≤ 28 business days (production time)
                    // Production: 22-28 business days
                    const productionDates = addBusinessDaysFromDate(orderConfirmedDate, 22 + offsetDays, 28 + offsetDays);
                    
                    // Shipping: 1-4 business days (from production completion)
                    const deliveredDates = {
                      min: addBusinessDays(productionDates.min, 1),
                      max: addBusinessDays(productionDates.max, 4)
                    };
                    
                    orderConfirmedEl.textContent = formatDate(orderConfirmedDate);
                    
                    if (productionDates.min.getTime() === productionDates.max.getTime()) {
                      shippedEl.textContent = formatDate(productionDates.min);
                    } else {
                      shippedEl.textContent = `${formatDate(productionDates.min)} to ${formatDate(productionDates.max)}`;
                    }
                    
                    if (deliveredDates.min.getTime() === deliveredDates.max.getTime()) {
                      deliveredEl.textContent = formatDate(deliveredDates.min);
                    } else {
                      deliveredEl.textContent = `${formatDate(deliveredDates.min)} to ${formatDate(deliveredDates.max)}`;
                    }
                    
                    // Update estimated delivery range
                    const estimatedRange = `${formatDate(deliveredDates.min)} to ${formatDate(deliveredDates.max)}`;
                    estimatedRangeEl.textContent = `Smart Saver (22–28 business days) ${estimatedRange}`;
                    
                    // Update footer for custom view
                    if (footerEl) {
                      footerEl.innerHTML = '<div style="margin-bottom: 4px;"><strong>Production:</strong> 22-28 business days</div><div><strong>Shipping:</strong> 1-4 business days</div>';
                    }
                  } else {
                    // Standard Express: 60% ≤ 8 business days, 95% ≤ 12 business days (production time)
                    // Production: 8-12 business days
                    const productionDates = addBusinessDaysFromDate(orderConfirmedDate, 8 + offsetDays, 12 + offsetDays);
                    
                    // Shipping: 1-4 business days (from production completion)
                    const deliveredDates = {
                      min: addBusinessDays(productionDates.min, 1),
                      max: addBusinessDays(productionDates.max, 4)
                    };
                    
                    orderConfirmedEl.textContent = formatDate(orderConfirmedDate);
                    
                    if (productionDates.min.getTime() === productionDates.max.getTime()) {
                      shippedEl.textContent = formatDate(productionDates.min);
                    } else {
                      shippedEl.textContent = `${formatDate(productionDates.min)} to ${formatDate(productionDates.max)}`;
                    }
                    
                    if (deliveredDates.min.getTime() === deliveredDates.max.getTime()) {
                      deliveredEl.textContent = formatDate(deliveredDates.min);
                    } else {
                      deliveredEl.textContent = `${formatDate(deliveredDates.min)} to ${formatDate(deliveredDates.max)}`;
                    }
                    
                    // Update estimated delivery range
                    const estimatedRange = `${formatDate(deliveredDates.min)} to ${formatDate(deliveredDates.max)}`;
                    estimatedRangeEl.textContent = `Standard Express (8–12 business days) ${estimatedRange}`;
                    
                    // Update footer for custom view
                    if (footerEl) {
                      footerEl.innerHTML = '<div style="margin-bottom: 4px;"><strong>Production:</strong> 8-12 business days</div><div><strong>Shipping:</strong> 1-4 business days</div>';
                    }
                  }
                }
                
                // Controller function to update delivery timeline UI
                function updateDeliveryTimelineUI() {
                  const customView = document.getElementById('custom-product-view');
                  const blankView = document.getElementById('blank-product-view');
                  
                  // Detect if we're in blanks mode (blank view is visible) or custom mode (custom view is visible)
                  const isBlanksMode = blankView && blankView.style.display !== 'none' && (!customView || customView.style.display === 'none');
                  
                  if (isBlanksMode) {
                    // Update plain timeline (it's in blank view, visibility handled by parent)
                    updatePlainDeliveryExpectations();
                  } else {
                    // Update custom timeline (it's in custom view, visibility handled by parent)
                    // Detect delivery method
                    const smartSaverRadio = document.getElementById('delivery-smart-saver');
                    const deliveryMode = (smartSaverRadio && smartSaverRadio.checked) ? 'smart_saver' : 'standard';
                    // When switching from blanks -> custom, add a small offset so custom timelines sit later
                    updateCustomDeliveryExpectations(deliveryMode, CUSTOM_EXTRA_DAYS);
                  }
                  
                  // Update estimated delivery time display
                  updateEstimatedDeliveryTimeDisplay();
                }
                
                // Update estimated delivery time display
                function updateEstimatedDeliveryTimeDisplay() {
                  const displayEl = document.getElementById('estimated-delivery-time-display');
                  if (!displayEl) return;
                  
                  const smartSaverRadio = document.getElementById('delivery-smart-saver');
                  const isSmartSaver = smartSaverRadio && smartSaverRadio.checked;
                  
                  if (isSmartSaver) {
                    displayEl.textContent = '22-28 business days';
                  } else {
                    displayEl.textContent = '8-12 business days';
                  }
                }
                
                // Initialize delivery expectations on page load
                if (document.readyState === 'loading') {
                  document.addEventListener('DOMContentLoaded', updateDeliveryTimelineUI);
                } else {
                  updateDeliveryTimelineUI();
                }
                
                // Make updateDeliveryTimelineUI available globally for external calls
                window.updateDeliveryTimelineUI = updateDeliveryTimelineUI;
                
                // Listen for delivery method changes to update timeline
                const deliveryMethodInputs = document.querySelectorAll('input[name="delivery-method"]');
                if (deliveryMethodInputs.length > 0) {
                  deliveryMethodInputs.forEach(input => {
                    input.addEventListener('change', function() {
                      if (window.updateDeliveryTimelineUI) {
                        window.updateDeliveryTimelineUI();
                      }
                    });
                  });
                }

                // Place delivery timeline under buy buttons when custom view is visible
                function placeDeliveryTimelineUnderBuyButtons() {
                  const timeline = document.getElementById('deliveryTimeline');
                  if (!timeline) return;

                  const customView = document.getElementById('custom-product-view');
                  if (!customView || customView.style.display === 'none') return;

                  // Find the buy buttons - look for product-form which contains the buy buttons
                  // Try multiple selectors to find the buy buttons container
                  let target = null;
                  
                  // First, try to find the product-form that contains the submit button
                  const productForms = customView.querySelectorAll('.product-form');
                  for (const form of productForms) {
                    const submitBtn = form.querySelector('button[type="submit"], .product-form__submit');
                    if (submitBtn) {
                      target = form;
                      break;
                    }
                  }
                  
                  // If no product-form found, try other selectors
                  if (!target) {
                    const selectors = [
                      '#custom-product-view .product-form__cart-submit',
                      '#custom-product-view .product-form__submit',
                      '#custom-product-view button[type="submit"]',
                      '#custom-product-view .custom-add-to-cart-wrapper',
                      '#custom-product-view .buy-buttons',
                    ];
                    
                    for (const sel of selectors) {
                      const el = document.querySelector(sel);
                      if (el) {
                        target = el.closest('.product-form') || el;
                        break;
                      }
                    }
                  }

                  // If we found a target, insert timeline after it
                  if (target && target.parentNode) {
                    // Remove timeline from current location if it exists elsewhere
                    if (timeline.parentNode) {
                      timeline.parentNode.removeChild(timeline);
                    }
                    // Insert after the target
                    if (target.nextSibling) {
                      target.parentNode.insertBefore(timeline, target.nextSibling);
                    } else {
                      target.parentNode.appendChild(timeline);
                    }
                    timeline.style.display = 'block';
                    timeline.style.visibility = 'visible';
                  } else {
                    // Fallback: append to custom view
                    if (customView) {
                      if (timeline.parentNode) {
                        timeline.parentNode.removeChild(timeline);
                      }
                      customView.appendChild(timeline);
                      timeline.style.display = 'block';
                      timeline.style.visibility = 'visible';
                    }
                  }
                }

                // Expose globally so other scripts can call it
                window.placeDeliveryTimelineUnderBuyButtons = placeDeliveryTimelineUnderBuyButtons;

                // Run on load and whenever the custom view changes visibility
                document.addEventListener('DOMContentLoaded', function() {
                  placeDeliveryTimelineUnderBuyButtons();

                  const customView = document.getElementById('custom-product-view');
                  if (customView) {
                    const mo = new MutationObserver(() => {
                      if (window.getComputedStyle(customView).display !== 'none') {
                        placeDeliveryTimelineUnderBuyButtons();
                      }
                    });
                    mo.observe(customView, { attributes: true, attributeFilter: ['style', 'class'] });
                  }

                  // Also observe for late-inserted buy buttons
                  const bodyObserver = new MutationObserver(() => {
                    placeDeliveryTimelineUnderBuyButtons();
                  });
                  bodyObserver.observe(document.body, { childList: true, subtree: true });
                });
                
                // Initialize Bulk Grid Modal Function
                window.initializeBulkGridModal = function() {
                  // Check if already initialized
                  const bulkGridBody = document.getElementById('bulkGridVariantGridBody');
                  if (!bulkGridBody || bulkGridBody.querySelectorAll('tr').length > 0) {
                    return; // Already initialized
                  }
                  
                  // Get product data
                  const _variantsEl = document.querySelector('script[id^="custom-main-product-variants-data-"]');
                  const _optionsEl = document.querySelector('script[id^="custom-main-product-options-data-"]');
                  
                  let productData = [];
                  let productOptions = [];
                  
                  try {
                    if (_variantsEl && _variantsEl.textContent) {
                      productData = JSON.parse(_variantsEl.textContent);
                    }
                  } catch (e) {
                    console.error('Error parsing product variants JSON:', e);
                  }
                  
                  try {
                    if (_optionsEl && _optionsEl.textContent) {
                      productOptions = JSON.parse(_optionsEl.textContent);
                    }
                  } catch (e) {
                    console.error('Error parsing product options JSON:', e);
                  }
                  
                  const sizeHeaderRow = document.getElementById('bulkGridSizeHeaderRow');
                  const gridBody = document.getElementById('bulkGridVariantGridBody');
                  
                  if (!sizeHeaderRow || !gridBody || !productData.length || !productOptions.length) {
                    console.log('Bulk grid modal: Missing required elements or data');
                    return;
                  }
                  
                  // Detect which option is Color and which is Size
                  let colorOptionIndex = -1;
                  let sizeOptionIndex = -1;
                  let otherOptionIndex = -1;
                  
                  productOptions.forEach((option, index) => {
                    const optionName = option.name.toLowerCase();
                    if (optionName.includes('color') || optionName.includes('colour')) {
                      colorOptionIndex = index;
                    } else if (optionName.includes('size')) {
                      sizeOptionIndex = index;
                    } else {
                      otherOptionIndex = index;
                    }
                  });
                  
                  // Setup other option selector if exists
                  let selectedOtherOption = null;
                  const otherOptionContainer = document.getElementById('bulkGridOtherVariantOption');
                  const otherOptionLabel = document.getElementById('bulkGridOtherVariantLabel');
                  const otherOptionButtons = document.getElementById('bulkGridOtherVariantButtons');
                  
                  const bulkOtherIsDelivery = otherOptionIndex >= 0 && productOptions[otherOptionIndex] &&
                    productOptions[otherOptionIndex].name.toLowerCase().includes('delivery');

                  if (bulkOtherIsDelivery) {
                    // Blanks always ship Standard (Air); Smart Saver is only offered on the custom view
                    const deliveryValues = productOptions[otherOptionIndex].values;
                    selectedOtherOption = deliveryValues.find(v => v.toLowerCase().includes('standard')) || deliveryValues[0];
                    if (otherOptionContainer) otherOptionContainer.style.display = 'none';
                  } else if (otherOptionIndex >= 0 && productOptions[otherOptionIndex] && otherOptionContainer) {
                    const otherOption = productOptions[otherOptionIndex];
                    otherOptionContainer.style.display = 'block';
                    otherOptionLabel.textContent = otherOption.name + ':';
                    
                    // Clear existing buttons
                    otherOptionButtons.innerHTML = '';
                    
                    // Create buttons for each value
                    otherOption.values.forEach((value, index) => {
                      const btn = document.createElement('button');
                      btn.type = 'button';
                      btn.className = 'other-variant-btn' + (index === 0 ? ' active' : '');
                      btn.textContent = value;
                      btn.dataset.value = value;
                      
                      btn.addEventListener('click', function() {
                        document.querySelectorAll('#bulkGridOtherVariantButtons .other-variant-btn').forEach(b => b.classList.remove('active'));
                        this.classList.add('active');
                        selectedOtherOption = value;
                        rebuildBulkGrid();
                      });
                      
                      otherOptionButtons.appendChild(btn);
                    });
                    
                    selectedOtherOption = otherOption.values[0];
                  }
                  
                  // Function to build/rebuild grid
                  function rebuildBulkGrid() {
                    // Clear existing grid
                    while (sizeHeaderRow.children.length > 1) {
                      sizeHeaderRow.removeChild(sizeHeaderRow.lastChild);
                    }
                    gridBody.innerHTML = '';
                    
                    // Extract unique colors and sizes
                    const colors = {};
                    const sizes = new Set();
                    
                    productData.forEach(variant => {
                      const color = colorOptionIndex >= 0 ? variant[`option${colorOptionIndex + 1}`] : null;
                      const rawSize = sizeOptionIndex >= 0 ? variant[`option${sizeOptionIndex + 1}`] : null;
                      const size = normalizeSizeLabel(rawSize);
                      const otherValue = otherOptionIndex >= 0 ? variant[`option${otherOptionIndex + 1}`] : null;
                      
                      if (selectedOtherOption && otherValue !== selectedOtherOption) {
                        return;
                      }
                      
                      if (!color || !rawSize) {
                        return;
                      }
                      
                      if (!colors[color]) {
                        colors[color] = {
                          image: variant.featured_image ? variant.featured_image.src : null,
                          sizes: {}
                        };
                      }
                      
                      colors[color].sizes[size] = {
                        variantId: variant.id,
                        available: variant.available,
                        price: variant.price
                      };
                      
                      sizes.add(size);
                    });
                    
                    // Convert sizes to array and sort
                    const sizeOrder = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
                    const sizesArray = Array.from(sizes).sort((a, b) => {
                      const aIndex = sizeOrder.indexOf(normalizeSizeKey(a));
                      const bIndex = sizeOrder.indexOf(normalizeSizeKey(b));
                      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
                      if (aIndex !== -1) return -1;
                      if (bIndex !== -1) return 1;
                      return a.localeCompare(b);
                    });
                    
                    // Build header row
                    sizesArray.forEach(size => {
                      const th = document.createElement('th');
                      th.textContent = size;
                      sizeHeaderRow.appendChild(th);
                    });
                    
                    // Build rows for each color
                    Object.keys(colors).forEach(color => {
                      const row = document.createElement('tr');
                      
                      // Color cell
                      const colorCell = document.createElement('td');
                      const colorDiv = document.createElement('div');
                      colorDiv.className = 'color-cell';
                      
                      if (colors[color].image) {
                        const img = document.createElement('img');
                        img.src = colors[color].image;
                        img.alt = color;
                        img.className = 'color-image';
                        colorDiv.appendChild(img);
                      }
                      
                      const colorName = document.createElement('span');
                      colorName.className = 'color-name';
                      colorName.textContent = color;
                      colorDiv.appendChild(colorName);
                      
                      colorCell.appendChild(colorDiv);
                      row.appendChild(colorCell);
                      
                      // Size cells
                      sizesArray.forEach(size => {
                        const sizeData = colors[color].sizes[size];
                        const sizeCell = document.createElement('td');
                        sizeCell.className = 'qty-input-cell';
                        
                        if (sizeData && sizeData.available) {
                          const input = document.createElement('input');
                          input.type = 'number';
                          input.min = '0';
                          // Set max to current slider value
                          const sliderMax = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : 0;
                          input.max = sliderMax > 0 ? String(sliderMax) : '';
                          input.value = '0';
                          input.dataset.variantId = sizeData.variantId;
                          input.dataset.color = color;
                          input.dataset.size = size;
                          sizeCell.appendChild(input);
                        } else {
                          sizeCell.classList.add('unavailable');
                        }
                        
                        row.appendChild(sizeCell);
                      });
                      
                      gridBody.appendChild(row);
                    });
                    
                    // Update summary
                    updateBulkGridSummary();
                  }
                  
                  // Function to update max values on all bulk grid inputs based on slider
                  function updateBulkGridMaxValues() {
                    const sliderMax = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : 0;
                    const inputs = gridBody.querySelectorAll('input[type="number"]');
                    inputs.forEach(input => {
                      if (sliderMax > 0) {
                        input.max = String(sliderMax);
                        // If current value exceeds max, clamp it
                        const currentValue = parseInt(input.value) || 0;
                        if (currentValue > sliderMax) {
                          input.value = String(sliderMax);
                        }
                      } else {
                        input.removeAttribute('max');
                      }
                    });
                    updateBulkGridSummary();
                  }
                  
                  // Handle quantity changes
                  const summaryDiv = document.getElementById('bulkGridSelectionSummary');
                  const addToCartBtn = document.getElementById('bulkGridAddToCart');
                  const trackerText = document.getElementById('bulkGridStepTrackerText');
                  
                  function updateBulkGridSummary() {
                    const inputs = gridBody.querySelectorAll('input[type="number"]');
                    let totalItems = 0;
                    const selections = [];
                    
                    inputs.forEach(input => {
                      const qty = parseInt(input.value) || 0;
                      if (qty > 0) {
                        totalItems += qty;
                        selections.push({
                          color: input.dataset.color,
                          size: input.dataset.size,
                          qty: qty,
                          variantId: input.dataset.variantId
                        });
                      }
                    });
                    
                    // Get slider max value
                    const sliderMax = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : 0;
                    const exceedsLimit = sliderMax > 0 && totalItems > sliderMax;
                    
                    // Update tracker (just show count, no "/10" for bulk grid)
                    if (trackerText) {
                      trackerText.textContent = `${totalItems} selected`;
                    }
                    
                    if (selections.length > 0) {
                      let html = '';
                      selections.forEach(sel => {
                        html += `<div class="summary-item">
                          <span>${sel.color} - ${sel.size}</span>
                          <span>×${sel.qty}</span>
                        </div>`;
                      });
                      html += `<div class="summary-item">
                        <span>Total Items</span>
                        <span>${totalItems}</span>
                      </div>`;
                      
                      // Show error message if exceeds limit
                      if (exceedsLimit) {
                        html += `<div class="summary-error" style="margin-top: 12px; padding: 10px; background: #fee; border: 1px solid #fcc; border-radius: 4px; color: #c33; font-size: 0.9em;">
                          <strong>Error:</strong> You have added ${totalItems} units, but the maximum allowed is ${sliderMax} units. Please reduce your quantities.
                        </div>`;
                      }
                      
                      summaryDiv.innerHTML = html;
                      // ABSOLUTELY disable button if limit exceeded - use setAttribute for stronger enforcement
                      if (exceedsLimit) {
                        addToCartBtn.disabled = true;
                        addToCartBtn.setAttribute('disabled', 'disabled');
                        addToCartBtn.style.opacity = '0.5';
                        addToCartBtn.style.cursor = 'not-allowed';
                      } else {
                        addToCartBtn.disabled = false;
                        addToCartBtn.removeAttribute('disabled');
                        addToCartBtn.style.opacity = '';
                        addToCartBtn.style.cursor = '';
                      }
                    } else {
                      summaryDiv.innerHTML = '';
                      addToCartBtn.disabled = true;
                      addToCartBtn.setAttribute('disabled', 'disabled');
                    }
                  }
                  
                  // Listen for quantity changes
                  gridBody.addEventListener('input', function(e) {
                    if (e.target.type === 'number') {
                      const sliderMax = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : 0;
                      const currentValue = parseInt(e.target.value) || 0;
                      
                      // First, enforce individual input max (can't exceed slider value per field)
                      if (sliderMax > 0 && currentValue > sliderMax) {
                        e.target.value = String(sliderMax);
                        return;
                      }
                      
                      // Then, check total across all inputs
                      const inputs = gridBody.querySelectorAll('input[type="number"]');
                      let totalItems = 0;
                      inputs.forEach(input => {
                        totalItems += parseInt(input.value) || 0;
                      });
                      
                      // If total exceeds slider max, reduce this input's value
                      if (sliderMax > 0 && totalItems > sliderMax) {
                        const otherInputsTotal = totalItems - currentValue;
                        const maxAllowedForThisInput = Math.max(0, sliderMax - otherInputsTotal);
                        e.target.value = String(maxAllowedForThisInput);
                      }
                      
                      updateBulkGridSummary();
                    }
                  });
                  
                  // Handle Add to Cart
                  addToCartBtn.addEventListener('click', async function(e) {
                    // ALWAYS prevent if button is disabled
                    if (addToCartBtn.disabled) {
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                      return false;
                    }
                    
                    const inputs = gridBody.querySelectorAll('input[type="number"]');
                    const items = [];
                    let totalItems = 0;
                    
                    inputs.forEach(input => {
                      const qty = parseInt(input.value) || 0;
                      if (qty > 0) {
                        totalItems += qty;
                        items.push({
                          id: input.dataset.variantId,
                          quantity: qty
                        });
                      }
                    });
                    
                    if (items.length === 0) {
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                      return false;
                    }
                    
                    // Validate against slider max value - CRITICAL CHECK - MUST BE FIRST VALIDATION
                    const sliderMax = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : 0;
                    if (sliderMax > 0 && totalItems > sliderMax) {
                      // ABSOLUTELY BLOCK cart addition
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                      
                      // Update summary to show error
                      updateBulkGridSummary();
                      
                      // Show alert
                      alert(`Error: You have added ${totalItems} units, but the maximum allowed is ${sliderMax} units. Please reduce your quantities.`);
                      
                      // Ensure button is disabled
                      addToCartBtn.disabled = true;
                      
                      return false;
                    }
                    
                    // DOUBLE CHECK before proceeding - final safeguard
                    if (sliderMax > 0 && totalItems > sliderMax) {
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                      addToCartBtn.disabled = true;
                      updateBulkGridSummary();
                      return false;
                    }
                    
                    // FINAL VALIDATION CHECK before API call - absolute last safeguard
                    const finalSliderMax = (typeof window.getSliderQuantity === 'function') ? window.getSliderQuantity() : 0;
                    let finalTotalItems = 0;
                    inputs.forEach(input => {
                      finalTotalItems += parseInt(input.value) || 0;
                    });
                    
                    if (finalSliderMax > 0 && finalTotalItems > finalSliderMax) {
                      // BLOCK the API call
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation();
                      addToCartBtn.disabled = true;
                      updateBulkGridSummary();
                      alert(`Error: You have added ${finalTotalItems} units, but the maximum allowed is ${finalSliderMax} units. Please reduce your quantities.`);
                      return false;
                    }
                    
                    // Show loading
                    const btnText = addToCartBtn.querySelector('.cart-btn-text');
                    const btnLoading = addToCartBtn.querySelector('.cart-btn-loading');
                    btnText.style.display = 'none';
                    btnLoading.style.display = 'block';
                    addToCartBtn.disabled = true;
                    
                    try {
                      const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ items })
                      });
                      
                      if (response.ok) {
                        // Success feedback
                        btnText.textContent = '✓ Added!';
                        btnText.style.display = 'block';
                        btnLoading.style.display = 'none';
                        
                        // Refresh cart
                        document.dispatchEvent(new CustomEvent('cart:refresh'));
                        
                        // Close modal after success
                        setTimeout(() => {
                          const modal = document.querySelector('modal-dialog[id^="BulkOrderGridModal-Blank-"]');
                          if (modal) {
                            if (modal.hide) {
                              modal.hide();
                            } else {
                              modal.removeAttribute('open');
                              modal.style.display = 'none';
                              document.body.classList.remove('overflow-hidden');
                            }
                          }
                          
                          // Reset form
                          btnText.textContent = 'Add to Cart';
                          inputs.forEach(input => input.value = '0');
                          updateBulkGridSummary();
                        }, 1500);
                      } else {
                        throw new Error('Failed to add to cart');
                      }
                    } catch (error) {
                      console.error('Error adding to cart:', error);
                      btnText.textContent = 'Error - Try Again';
                      btnText.style.display = 'block';
                      btnLoading.style.display = 'none';
                      addToCartBtn.disabled = false;
                      
                      setTimeout(() => {
                        btnText.textContent = 'Add to Cart';
                      }, 2000);
                    }
                  });
                  
                  // Build initial grid
                  rebuildBulkGrid();
                  
                  // Listen for slider changes to update max values
                  const volumeSlider = document.getElementById('volume-quantity-slider');
                  if (volumeSlider) {
                    volumeSlider.addEventListener('input', updateBulkGridMaxValues);
                    volumeSlider.addEventListener('change', updateBulkGridMaxValues);
                  }
                };
              });

  // ---------- Mobile custom select helpers ----------
  // Detect touch-capable device
  function isTouchDevice() {
    try {
      return ('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
    } catch (e) {
      return false;
    }
  }

  // Create a simple custom dropdown that mirrors a native <select>.
  // Keeps the original <select> hidden for form submission but shows an in-page menu.
  function createCustomSelect(originalSelect) {
    if (!originalSelect || originalSelect.dataset.customized === '1') return;
    // mark as customized
    originalSelect.dataset.customized = '1';
    // hide native select (still present for form)
    originalSelect.style.display = 'none';

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-select';
    if (originalSelect.classList && originalSelect.classList.contains('area-select')) {
      wrapper.classList.add('custom-select--print-area');
    }

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select-trigger';
    const initialText = (originalSelect.options[originalSelect.selectedIndex] && originalSelect.options[originalSelect.selectedIndex].text) || 'Choose area...';
    trigger.textContent = initialText;
    if (originalSelect.classList && originalSelect.classList.contains('area-select')) {
      trigger.setAttribute('aria-label', 'Choose print area');
    }
    wrapper.appendChild(trigger);

    const menu = document.createElement('div');
    menu.className = 'custom-select-menu';

    Array.from(originalSelect.options).forEach(opt => {
      const item = document.createElement('div');
      item.className = 'custom-select-item';
      item.textContent = opt.text;
      item.dataset.value = opt.value;
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        // set the native select value (for form submission and any existing listeners)
        originalSelect.value = item.dataset.value;
        // update trigger text
        trigger.textContent = item.textContent;
        // close menu
        menu.classList.remove('open');
        // notify existing change handler
        originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
      menu.appendChild(item);
    });

    wrapper.appendChild(menu);
    // insert after the native select
    originalSelect.parentNode.insertBefore(wrapper, originalSelect.nextSibling);

    // toggle menu
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      // close other open menus
      document.querySelectorAll('.custom-select-menu.open').forEach(m => {
        if (m !== menu) m.classList.remove('open');
      });
      menu.classList.toggle('open');
    });

    // close on outside click/touch
    document.addEventListener('click', () => menu.classList.remove('open'));
    document.addEventListener('touchstart', () => menu.classList.remove('open'));

    // prevent touch interactions from bubbling when interacting with the menu
    menu.addEventListener('touchstart', (e) => e.stopPropagation());
  }

// Volume slider: one-time subtle hint toward Smart Saver MOQ (data-moq) when custom view is active.
function initVolumeSliderHint() {
  if (window.__volumeSliderHintBound) return;
  window.__volumeSliderHintBound = true;

  const SESSION_KEY = 'volumeSliderHintShown_v3';
  const HINT_DELAY_MS = 1600;
  const MOVE_MS = 1040;
  const PAUSE_MS = 640;
  const RETURN_MS = 1040;

  let scheduleTimer = null;
  let visibilityObserver = null;
  let hintAnimating = false;
  let pendingBaseline = null;

  function disconnectVisibilityObserver() {
    if (visibilityObserver) {
      try {
        visibilityObserver.disconnect();
      } catch (e) { /* ignore */ }
      visibilityObserver = null;
    }
  }

  /** True when enough of the slider block is on-screen (user can see it). */
  function isSliderBlockVisible(wrapper) {
    if (!wrapper || typeof wrapper.getBoundingClientRect !== 'function') return false;
    const r = wrapper.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;
    if (r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) return false;
    const visibleH = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    const visibleW = Math.min(r.right, vw) - Math.max(r.left, 0);
    const total = r.width * r.height;
    if (total <= 0) return false;
    const ratio = (visibleH * visibleW) / total;
    return ratio >= 0.06;
  }

  function isCustomViewVisible() {
    const el = document.getElementById('custom-product-view');
    if (!el) return false;
    return window.getComputedStyle(el).display !== 'none';
  }

  function getSliderAndWrapper() {
    const root = document.getElementById('custom-product-view');
    const slider = root
      ? root.querySelector('#volume-quantity-slider')
      : document.getElementById('volume-quantity-slider');
    const wrapper = root
      ? root.querySelector('.volume-discount-slider-wrapper')
      : document.querySelector('.volume-discount-slider-wrapper');
    if (!slider || !wrapper) return null;
    return { slider, wrapper };
  }

  function getSliderQty(slider) {
    if (typeof window.getSliderQuantity === 'function') {
      const q = window.getSliderQuantity();
      if (Number.isFinite(q) && q >= 0) return q;
    }
    const v = parseInt(slider.value, 10);
    return Number.isFinite(v) ? v : NaN;
  }

  function parseSliderMinMax(slider) {
    let min = parseInt(slider.min, 10);
    let max = parseInt(slider.max, 10);
    if (!Number.isFinite(min)) min = 1;
    if (!Number.isFinite(max)) max = 100;
    return { min, max };
  }

  function resolveHintTarget(wrapper, slider) {
    const { min, max } = parseSliderMinMax(slider);
    const rawMoq = parseInt(wrapper.dataset.moq, 10);
    let moqCandidate;
    if (Number.isFinite(rawMoq) && rawMoq >= 1 && rawMoq <= 100) {
      moqCandidate = rawMoq;
    } else {
      moqCandidate = Math.min(30, max);
    }
    const target = Math.max(min, Math.min(moqCandidate, max));
    return { target, min, max };
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function syncSliderStep(slider, intVal, withChange, options) {
    const skipInput = options && options.skipInput;
    const v = String(intVal);
    slider.value = v;
    try {
      slider.setAttribute('value', v);
    } catch (e) { /* ignore */ }
    // During the hint tween, avoid dispatching 'input': the volume script calls
    // enforcePrintingMethodMOQ() on every input and would snap the thumb mid-animation.
    if (!skipInput) {
      slider.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (typeof window.updateDisplays === 'function') {
      try {
        window.updateDisplays(intVal);
      } catch (e) { /* ignore */ }
    }
    if (withChange) {
      slider.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function runSegment(slider, from, to, durationMs, restoreOnAbort, done) {
    const start = performance.now();
    const fromR = Math.round(from);
    const toR = Math.round(to);
    function frame(now) {
      if (!isCustomViewVisible()) {
        const restore = restoreOnAbort != null ? Math.round(restoreOnAbort) : fromR;
        syncSliderStep(slider, restore, true);
        done(true);
        return;
      }
      const elapsed = now - start;
      const t = Math.min(1, elapsed / durationMs);
      const eased = easeOutCubic(t);
      const value = fromR + (toR - fromR) * eased;
      syncSliderStep(slider, Math.round(value), false, { skipInput: true });
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        syncSliderStep(slider, toR, false, { skipInput: true });
        done(false);
      }
    }
    requestAnimationFrame(frame);
  }

  function markHintShown() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) { /* ignore */ }
  }

  /** @returns {boolean} true when finished or skipped for good; false = re-arm visibility wait */
  function runVolumeSliderHint() {
    if (hintAnimating) return true;
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return true;
    } catch (e) {
      return true;
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      markHintShown();
      return true;
    }
    if (!isCustomViewVisible()) return true;

    const sw = getSliderAndWrapper();
    if (!sw) return true;

    const { slider, wrapper } = sw;
    const startVal = getSliderQty(slider);
    if (!Number.isFinite(startVal)) return true;

    if (pendingBaseline !== null && getSliderQty(slider) !== pendingBaseline) {
      return true;
    }

    if (!isSliderBlockVisible(wrapper)) {
      return false;
    }

    const { target } = resolveHintTarget(wrapper, slider);
    if (target === startVal) {
      markHintShown();
      return true;
    }

    markHintShown();
    hintAnimating = true;
    wrapper.classList.add('volume-slider-hint-active');

    runSegment(slider, startVal, target, MOVE_MS, startVal, function (aborted) {
      if (aborted) {
        wrapper.classList.remove('volume-slider-hint-active');
        hintAnimating = false;
        return;
      }
      setTimeout(function () {
        runSegment(slider, target, startVal, RETURN_MS, startVal, function (aborted2) {
          wrapper.classList.remove('volume-slider-hint-active');
          hintAnimating = false;
          if (!aborted2) {
            syncSliderStep(slider, startVal, true);
          }
        });
      }, PAUSE_MS);
    });
    return true;
  }

  function scheduleHint() {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
    } catch (e) {
      return;
    }
    if (!isCustomViewVisible()) return;

    // Post-visibility delay is armed — do not reset (MutationObserver / duplicate tab hooks fire often).
    if (scheduleTimer) {
      return;
    }

    disconnectVisibilityObserver();

    const sw = getSliderAndWrapper();
    if (!sw) return;

    pendingBaseline = getSliderQty(sw.slider);
    if (!Number.isFinite(pendingBaseline)) {
      pendingBaseline = null;
      return;
    }

    const { wrapper } = sw;

    function armDelayAfterVisible() {
      if (scheduleTimer) {
        clearTimeout(scheduleTimer);
        scheduleTimer = null;
      }
      scheduleTimer = setTimeout(function () {
        scheduleTimer = null;
        const done = runVolumeSliderHint();
        if (done) {
          pendingBaseline = null;
        } else {
          scheduleHint();
        }
      }, HINT_DELAY_MS);
    }

    if (!('IntersectionObserver' in window)) {
      armDelayAfterVisible();
      return;
    }

    visibilityObserver = new IntersectionObserver(
      function (entries) {
        for (let i = 0; i < entries.length; i++) {
          const entry = entries[i];
          if (!entry.isIntersecting || entry.intersectionRatio < 0.05) continue;
          if (!isCustomViewVisible()) continue;
          disconnectVisibilityObserver();
          armDelayAfterVisible();
          return;
        }
      },
      { root: null, rootMargin: '0px', threshold: [0, 0.05, 0.1, 0.15, 0.25, 0.4, 0.6, 1] }
    );
    visibilityObserver.observe(wrapper);
    if (typeof visibilityObserver.takeRecords === 'function') {
      const records = visibilityObserver.takeRecords();
      for (let j = 0; j < records.length; j++) {
        const entry = records[j];
        if (!entry.isIntersecting || entry.intersectionRatio < 0.05) continue;
        if (!isCustomViewVisible()) continue;
        disconnectVisibilityObserver();
        armDelayAfterVisible();
        return;
      }
    }
  }

  function onCustomViewMaybeShown() {
    if (!isCustomViewVisible()) {
      if (scheduleTimer) {
        clearTimeout(scheduleTimer);
        scheduleTimer = null;
      }
      disconnectVisibilityObserver();
      pendingBaseline = null;
      return;
    }
    scheduleHint();
  }

  const customView = document.getElementById('custom-product-view');
  if (customView) {
    const mo = new MutationObserver(function () {
      onCustomViewMaybeShown();
    });
    mo.observe(customView, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // Bubble on document so this runs after per-tab handlers (e.g. inline switchView) update display.
  document.addEventListener(
    'click',
    function (e) {
      const tab = e.target && e.target.closest && e.target.closest('.product-mode-tab[data-view="custom"]');
      if (!tab) return;
      setTimeout(onCustomViewMaybeShown, 0);
      setTimeout(onCustomViewMaybeShown, 100);
    },
    false
  );

  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#custom-product-view') {
      setTimeout(onCustomViewMaybeShown, 120);
    }
  });

  if (isCustomViewVisible()) {
    onCustomViewMaybeShown();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVolumeSliderHint);
} else {
  initVolumeSliderHint();
}
